function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * Swiper 5.3.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://swiperjs.com
 *
 * Copyright 2014-2020 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: February 29, 2020
 */

!function (e, t) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = t() : typeof define === 'function' && define.amd ? define(t) : (e = e || self).Swiper = t();
}(this, function () {
  var e = typeof document === 'undefined' ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ''
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    location: {
      hash: ''
    }
  } : document;
  var t = typeof window === 'undefined' ? {
    document: e,
    navigator: {
      userAgent: ''
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return '';
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {}
  } : window;
  var i = function i(e) {
    for (var _t = 0; _t < e.length; _t += 1) this[_t] = e[_t];
    return this.length = e.length, this;
  };
  function s(s, a) {
    var r = [];
    var n = 0;
    if (s && !a && s instanceof i) return s;
    if (s) if (typeof s === 'string') {
      var _o;
      var _l;
      var _d = s.trim();
      if (_d.indexOf('<') >= 0 && _d.indexOf('>') >= 0) {
        var _h = 'div';
        for (_d.indexOf('<li') === 0 && (_h = 'ul'), _d.indexOf('<tr') === 0 && (_h = 'tbody'), _d.indexOf('<td') !== 0 && _d.indexOf('<th') !== 0 || (_h = 'tr'), _d.indexOf('<tbody') === 0 && (_h = 'table'), _d.indexOf('<option') === 0 && (_h = 'select'), (_l = e.createElement(_h)).innerHTML = _d, n = 0; n < _l.childNodes.length; n += 1) r.push(_l.childNodes[n]);
      } else for (_o = a || s[0] !== '#' || s.match(/[ .<>:~]/) ? (a || e).querySelectorAll(s.trim()) : [e.getElementById(s.trim().split('#')[1])], n = 0; n < _o.length; n += 1) _o[n] && r.push(_o[n]);
    } else if (s.nodeType || s === t || s === e) r.push(s);else if (s.length > 0 && s[0].nodeType) for (n = 0; n < s.length; n += 1) r.push(s[n]);
    return new i(r);
  }
  function a(e) {
    for (var t = [], i = 0; i < e.length; i += 1) t.indexOf(e[i]) === -1 && t.push(e[i]);
    return t;
  }
  s.fn = i.prototype, s.Class = i, s.Dom7 = i;
  var r = {
    addClass: function addClass(e) {
      if (void 0 === e) return this;
      for (var _t2 = e.split(' '), _i = 0; _i < _t2.length; _i += 1) for (var _s = 0; _s < this.length; _s += 1) void 0 !== this[_s] && void 0 !== this[_s].classList && this[_s].classList.add(_t2[_i]);
      return this;
    },
    removeClass: function removeClass(e) {
      for (var _t3 = e.split(' '), _i2 = 0; _i2 < _t3.length; _i2 += 1) for (var _s2 = 0; _s2 < this.length; _s2 += 1) void 0 !== this[_s2] && void 0 !== this[_s2].classList && this[_s2].classList.remove(_t3[_i2]);
      return this;
    },
    hasClass: function hasClass(e) {
      return !!this[0] && this[0].classList.contains(e);
    },
    toggleClass: function toggleClass(e) {
      for (var _t4 = e.split(' '), _i3 = 0; _i3 < _t4.length; _i3 += 1) for (var _s3 = 0; _s3 < this.length; _s3 += 1) void 0 !== this[_s3] && void 0 !== this[_s3].classList && this[_s3].classList.toggle(_t4[_i3]);
      return this;
    },
    attr: function attr(e, t) {
      var i = arguments;
      if (arguments.length === 1 && typeof e === 'string') return this[0] ? this[0].getAttribute(e) : void 0;
      for (var _s4 = 0; _s4 < this.length; _s4 += 1) if (i.length === 2) this[_s4].setAttribute(e, t);else for (var _a in e) this[_s4][_a] = e[_a], this[_s4].setAttribute(_a, e[_a]);
      return this;
    },
    removeAttr: function removeAttr(e) {
      for (var _t5 = 0; _t5 < this.length; _t5 += 1) this[_t5].removeAttribute(e);
      return this;
    },
    data: function data(e, t) {
      var i;
      if (void 0 !== t) {
        for (var _s5 = 0; _s5 < this.length; _s5 += 1) (i = this[_s5]).dom7ElementDataStorage || (i.dom7ElementDataStorage = {}), i.dom7ElementDataStorage[e] = t;
        return this;
      }
      if (i = this[0]) {
        if (i.dom7ElementDataStorage && e in i.dom7ElementDataStorage) return i.dom7ElementDataStorage[e];
        var _a2 = i.getAttribute("data-".concat(e));
        return _a2 || void 0;
      }
    },
    transform: function transform(e) {
      for (var _t6 = 0; _t6 < this.length; _t6 += 1) {
        var _i4 = this[_t6].style;
        _i4.webkitTransform = e, _i4.transform = e;
      }
      return this;
    },
    transition: function transition(e) {
      typeof e !== 'string' && (e += 'ms');
      for (var _t7 = 0; _t7 < this.length; _t7 += 1) {
        var _i5 = this[_t7].style;
        _i5.webkitTransitionDuration = e, _i5.transitionDuration = e;
      }
      return this;
    },
    on: function on() {
      for (var e, t = [], i = arguments.length; i--;) t[i] = arguments[i];
      var a = t[0];
      var r = t[1];
      var n = t[2];
      var o = t[3];
      function l(e) {
        var t = e.target;
        if (t) {
          var _i6 = e.target.dom7EventData || [];
          if (_i6.indexOf(e) < 0 && _i6.unshift(e), s(t).is(r)) n.apply(t, _i6);else for (var _a3 = s(t).parents(), _o2 = 0; _o2 < _a3.length; _o2 += 1) s(_a3[_o2]).is(r) && n.apply(_a3[_o2], _i6);
        }
      }
      function d(e) {
        var t = e && e.target && e.target.dom7EventData || [];
        t.indexOf(e) < 0 && t.unshift(e), n.apply(this, t);
      }
      typeof t[1] === 'function' && (a = (e = t)[0], n = e[1], o = e[2], r = void 0), o || (o = !1);
      for (var h, p = a.split(' '), c = 0; c < this.length; c += 1) {
        var _u = this[c];
        if (r) for (h = 0; h < p.length; h += 1) {
          var _v = p[h];
          _u.dom7LiveListeners || (_u.dom7LiveListeners = {}), _u.dom7LiveListeners[_v] || (_u.dom7LiveListeners[_v] = []), _u.dom7LiveListeners[_v].push({
            listener: n,
            proxyListener: l
          }), _u.addEventListener(_v, l, o);
        } else for (h = 0; h < p.length; h += 1) {
          var _f = p[h];
          _u.dom7Listeners || (_u.dom7Listeners = {}), _u.dom7Listeners[_f] || (_u.dom7Listeners[_f] = []), _u.dom7Listeners[_f].push({
            listener: n,
            proxyListener: d
          }), _u.addEventListener(_f, d, o);
        }
      }
      return this;
    },
    off: function off() {
      for (var e, t = [], i = arguments.length; i--;) t[i] = arguments[i];
      var s = t[0];
      var a = t[1];
      var r = t[2];
      var n = t[3];
      typeof t[1] === 'function' && (s = (e = t)[0], r = e[1], n = e[2], a = void 0), n || (n = !1);
      for (var _o3 = s.split(' '), _l2 = 0; _l2 < _o3.length; _l2 += 1) for (var _d2 = _o3[_l2], _h2 = 0; _h2 < this.length; _h2 += 1) {
        var _p = this[_h2];
        var _c = void 0;
        if (!a && _p.dom7Listeners ? _c = _p.dom7Listeners[_d2] : a && _p.dom7LiveListeners && (_c = _p.dom7LiveListeners[_d2]), _c && _c.length) for (var _u2 = _c.length - 1; _u2 >= 0; _u2 -= 1) {
          var _v2 = _c[_u2];
          r && _v2.listener === r ? (_p.removeEventListener(_d2, _v2.proxyListener, n), _c.splice(_u2, 1)) : r && _v2.listener && _v2.listener.dom7proxy && _v2.listener.dom7proxy === r ? (_p.removeEventListener(_d2, _v2.proxyListener, n), _c.splice(_u2, 1)) : r || (_p.removeEventListener(_d2, _v2.proxyListener, n), _c.splice(_u2, 1));
        }
      }
      return this;
    },
    trigger: function trigger() {
      for (var i = [], s = arguments.length; s--;) i[s] = arguments[s];
      for (var _a4 = i[0].split(' '), _r = i[1], _n = 0; _n < _a4.length; _n += 1) for (var _o4 = _a4[_n], _l3 = 0; _l3 < this.length; _l3 += 1) {
        var _d3 = this[_l3];
        var _h3 = void 0;
        try {
          _h3 = new t.CustomEvent(_o4, {
            detail: _r,
            bubbles: !0,
            cancelable: !0
          });
        } catch (t) {
          (_h3 = e.createEvent('Event')).initEvent(_o4, !0, !0), _h3.detail = _r;
        }
        _d3.dom7EventData = i.filter(function (e, t) {
          return t > 0;
        }), _d3.dispatchEvent(_h3), _d3.dom7EventData = [], delete _d3.dom7EventData;
      }
      return this;
    },
    transitionEnd: function transitionEnd(e) {
      var t;
      var i = ['webkitTransitionEnd', 'transitionend'];
      var s = this;
      function a(r) {
        if (r.target === this) for (e.call(this, r), t = 0; t < i.length; t += 1) s.off(i[t], a);
      }
      if (e) for (t = 0; t < i.length; t += 1) s.on(i[t], a);
      return this;
    },
    outerWidth: function outerWidth(e) {
      if (this.length > 0) {
        if (e) {
          var _t8 = this.styles();
          return this[0].offsetWidth + parseFloat(_t8.getPropertyValue('margin-right')) + parseFloat(_t8.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
      }
      return null;
    },
    outerHeight: function outerHeight(e) {
      if (this.length > 0) {
        if (e) {
          var _t9 = this.styles();
          return this[0].offsetHeight + parseFloat(_t9.getPropertyValue('margin-top')) + parseFloat(_t9.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
      }
      return null;
    },
    offset: function offset() {
      if (this.length > 0) {
        var _i7 = this[0];
        var _s6 = _i7.getBoundingClientRect();
        var _a5 = e.body;
        var _r2 = _i7.clientTop || _a5.clientTop || 0;
        var _n2 = _i7.clientLeft || _a5.clientLeft || 0;
        var _o5 = _i7 === t ? t.scrollY : _i7.scrollTop;
        var _l4 = _i7 === t ? t.scrollX : _i7.scrollLeft;
        return {
          top: _s6.top + _o5 - _r2,
          left: _s6.left + _l4 - _n2
        };
      }
      return null;
    },
    css: function css(e, i) {
      var s;
      if (arguments.length === 1) {
        if (typeof e !== 'string') {
          for (s = 0; s < this.length; s += 1) for (var _a6 in e) this[s].style[_a6] = e[_a6];
          return this;
        }
        if (this[0]) return t.getComputedStyle(this[0], null).getPropertyValue(e);
      }
      if (arguments.length === 2 && typeof e === 'string') {
        for (s = 0; s < this.length; s += 1) this[s].style[e] = i;
        return this;
      }
      return this;
    },
    each: function each(e) {
      if (!e) return this;
      for (var _t10 = 0; _t10 < this.length; _t10 += 1) if (!1 === e.call(this[_t10], _t10, this[_t10])) return this;
      return this;
    },
    html: function html(e) {
      if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
      for (var _t11 = 0; _t11 < this.length; _t11 += 1) this[_t11].innerHTML = e;
      return this;
    },
    text: function text(e) {
      if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
      for (var _t12 = 0; _t12 < this.length; _t12 += 1) this[_t12].textContent = e;
      return this;
    },
    is: function is(a) {
      var r;
      var n;
      var o = this[0];
      if (!o || void 0 === a) return !1;
      if (typeof a === 'string') {
        if (o.matches) return o.matches(a);
        if (o.webkitMatchesSelector) return o.webkitMatchesSelector(a);
        if (o.msMatchesSelector) return o.msMatchesSelector(a);
        for (r = s(a), n = 0; n < r.length; n += 1) if (r[n] === o) return !0;
        return !1;
      }
      if (a === e) return o === e;
      if (a === t) return o === t;
      if (a.nodeType || a instanceof i) {
        for (r = a.nodeType ? [a] : a, n = 0; n < r.length; n += 1) if (r[n] === o) return !0;
        return !1;
      }
      return !1;
    },
    index: function index() {
      var e;
      var t = this[0];
      if (t) {
        for (e = 0; (t = t.previousSibling) !== null;) t.nodeType === 1 && (e += 1);
        return e;
      }
    },
    eq: function eq(e) {
      if (void 0 === e) return this;
      var t;
      var s = this.length;
      return new i(e > s - 1 ? [] : e < 0 ? (t = s + e) < 0 ? [] : [this[t]] : [this[e]]);
    },
    append: function append() {
      for (var t, s = [], a = arguments.length; a--;) s[a] = arguments[a];
      for (var _r3 = 0; _r3 < s.length; _r3 += 1) {
        t = s[_r3];
        for (var _n3 = 0; _n3 < this.length; _n3 += 1) if (typeof t === 'string') {
          var _o6 = e.createElement('div');
          for (_o6.innerHTML = t; _o6.firstChild;) this[_n3].appendChild(_o6.firstChild);
        } else if (t instanceof i) for (var _l5 = 0; _l5 < t.length; _l5 += 1) this[_n3].appendChild(t[_l5]);else this[_n3].appendChild(t);
      }
      return this;
    },
    prepend: function prepend(t) {
      var s;
      var a;
      for (s = 0; s < this.length; s += 1) if (typeof t === 'string') {
        var _r4 = e.createElement('div');
        for (_r4.innerHTML = t, a = _r4.childNodes.length - 1; a >= 0; a -= 1) this[s].insertBefore(_r4.childNodes[a], this[s].childNodes[0]);
      } else if (t instanceof i) for (a = 0; a < t.length; a += 1) this[s].insertBefore(t[a], this[s].childNodes[0]);else this[s].insertBefore(t, this[s].childNodes[0]);
      return this;
    },
    next: function next(e) {
      return this.length > 0 ? e ? this[0].nextElementSibling && s(this[0].nextElementSibling).is(e) ? new i([this[0].nextElementSibling]) : new i([]) : this[0].nextElementSibling ? new i([this[0].nextElementSibling]) : new i([]) : new i([]);
    },
    nextAll: function nextAll(e) {
      var t = [];
      var a = this[0];
      if (!a) return new i([]);
      for (; a.nextElementSibling;) {
        var _r5 = a.nextElementSibling;
        e ? s(_r5).is(e) && t.push(_r5) : t.push(_r5), a = _r5;
      }
      return new i(t);
    },
    prev: function prev(e) {
      if (this.length > 0) {
        var _t13 = this[0];
        return e ? _t13.previousElementSibling && s(_t13.previousElementSibling).is(e) ? new i([_t13.previousElementSibling]) : new i([]) : _t13.previousElementSibling ? new i([_t13.previousElementSibling]) : new i([]);
      }
      return new i([]);
    },
    prevAll: function prevAll(e) {
      var t = [];
      var a = this[0];
      if (!a) return new i([]);
      for (; a.previousElementSibling;) {
        var _r6 = a.previousElementSibling;
        e ? s(_r6).is(e) && t.push(_r6) : t.push(_r6), a = _r6;
      }
      return new i(t);
    },
    parent: function parent(e) {
      for (var t = [], i = 0; i < this.length; i += 1) this[i].parentNode !== null && (e ? s(this[i].parentNode).is(e) && t.push(this[i].parentNode) : t.push(this[i].parentNode));
      return s(a(t));
    },
    parents: function parents(e) {
      for (var t = [], i = 0; i < this.length; i += 1) for (var _r7 = this[i].parentNode; _r7;) e ? s(_r7).is(e) && t.push(_r7) : t.push(_r7), _r7 = _r7.parentNode;
      return s(a(t));
    },
    closest: function closest(e) {
      var t = this;
      return void 0 === e ? new i([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
    },
    find: function find(e) {
      for (var t = [], s = 0; s < this.length; s += 1) for (var _a7 = this[s].querySelectorAll(e), _r8 = 0; _r8 < _a7.length; _r8 += 1) t.push(_a7[_r8]);
      return new i(t);
    },
    children: function children(e) {
      for (var t = [], r = 0; r < this.length; r += 1) for (var _n4 = this[r].childNodes, _o7 = 0; _o7 < _n4.length; _o7 += 1) e ? _n4[_o7].nodeType === 1 && s(_n4[_o7]).is(e) && t.push(_n4[_o7]) : _n4[_o7].nodeType === 1 && t.push(_n4[_o7]);
      return new i(a(t));
    },
    filter: function filter(e) {
      for (var t = [], s = 0; s < this.length; s += 1) e.call(this[s], s, this[s]) && t.push(this[s]);
      return new i(t);
    },
    remove: function remove() {
      for (var _e = 0; _e < this.length; _e += 1) this[_e].parentNode && this[_e].parentNode.removeChild(this[_e]);
      return this;
    },
    add: function add() {
      for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
      var i;
      var a;
      for (i = 0; i < e.length; i += 1) {
        var _r9 = s(e[i]);
        for (a = 0; a < _r9.length; a += 1) this[this.length] = _r9[a], this.length += 1;
      }
      return this;
    },
    styles: function styles() {
      return this[0] ? t.getComputedStyle(this[0], null) : {};
    }
  };
  Object.keys(r).forEach(function (e) {
    s.fn[e] = s.fn[e] || r[e];
  });
  var n = {
    deleteProps: function deleteProps(e) {
      var t = e;
      Object.keys(t).forEach(function (e) {
        try {
          t[e] = null;
        } catch (e) {}
        try {
          delete t[e];
        } catch (e) {}
      });
    },
    nextTick: function nextTick(e, t) {
      return void 0 === t && (t = 0), setTimeout(e, t);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(e, i) {
      var s;
      var a;
      var r;
      void 0 === i && (i = 'x');
      var n = t.getComputedStyle(e, null);
      return t.WebKitCSSMatrix ? ((a = n.transform || n.webkitTransform).split(',').length > 6 && (a = a.split(', ').map(function (e) {
        return e.replace(',', '.');
      }).join(', ')), r = new t.WebKitCSSMatrix(a === 'none' ? '' : a)) : s = (r = n.MozTransform || n.OTransform || n.MsTransform || n.msTransform || n.transform || n.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,')).toString().split(','), i === 'x' && (a = t.WebKitCSSMatrix ? r.m41 : s.length === 16 ? parseFloat(s[12]) : parseFloat(s[4])), i === 'y' && (a = t.WebKitCSSMatrix ? r.m42 : s.length === 16 ? parseFloat(s[13]) : parseFloat(s[5])), a || 0;
    },
    parseUrlQuery: function parseUrlQuery(e) {
      var i;
      var s;
      var a;
      var r;
      var n = {};
      var o = e || t.location.href;
      if (typeof o === 'string' && o.length) for (r = (s = (o = o.indexOf('?') > -1 ? o.replace(/\S*\?/, '') : '').split('&').filter(function (e) {
        return e !== '';
      })).length, i = 0; i < r; i += 1) a = s[i].replace(/#\S+/g, '').split('='), n[decodeURIComponent(a[0])] = void 0 === a[1] ? void 0 : decodeURIComponent(a[1]) || '';
      return n;
    },
    isObject: function isObject(e) {
      return _typeof(e) === 'object' && e !== null && e.constructor && e.constructor === Object;
    },
    extend: function extend() {
      for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
      for (var i = Object(e[0]), s = 1; s < e.length; s += 1) {
        var _a8 = e[s];
        if (_a8 != null) for (var _r10 = Object.keys(Object(_a8)), _o8 = 0, _l6 = _r10.length; _o8 < _l6; _o8 += 1) {
          var _d4 = _r10[_o8];
          var _h4 = Object.getOwnPropertyDescriptor(_a8, _d4);
          void 0 !== _h4 && _h4.enumerable && (n.isObject(i[_d4]) && n.isObject(_a8[_d4]) ? n.extend(i[_d4], _a8[_d4]) : !n.isObject(i[_d4]) && n.isObject(_a8[_d4]) ? (i[_d4] = {}, n.extend(i[_d4], _a8[_d4])) : i[_d4] = _a8[_d4]);
        }
      }
      return i;
    }
  };
  var o = {
    touch: t.Modernizr && !0 === t.Modernizr.touch || !!(t.navigator.maxTouchPoints > 0 || 'ontouchstart' in t || t.DocumentTouch && e instanceof t.DocumentTouch),
    pointerEvents: !!t.PointerEvent && 'maxTouchPoints' in t.navigator && t.navigator.maxTouchPoints > 0,
    observer: 'MutationObserver' in t || 'WebkitMutationObserver' in t,
    passiveListener: function () {
      var e = !1;
      try {
        var _i8 = Object.defineProperty({}, 'passive', {
          get: function get() {
            e = !0;
          }
        });
        t.addEventListener('testPassiveListener', null, _i8);
      } catch (e) {}
      return e;
    }(),
    gestures: 'ongesturestart' in t
  };
  var l = function l(e) {
    void 0 === e && (e = {});
    var t = this;
    t.params = e, t.eventsListeners = {}, t.params && t.params.on && Object.keys(t.params.on).forEach(function (e) {
      t.on(e, t.params.on[e]);
    });
  };
  var d = {
    components: {
      configurable: !0
    }
  };
  l.prototype.on = function (e, t, i) {
    var s = this;
    if (typeof t !== 'function') return s;
    var a = i ? 'unshift' : 'push';
    return e.split(' ').forEach(function (e) {
      s.eventsListeners[e] || (s.eventsListeners[e] = []), s.eventsListeners[e][a](t);
    }), s;
  }, l.prototype.once = function (e, t, i) {
    var s = this;
    if (typeof t !== 'function') return s;
    function a() {
      for (var i = [], r = arguments.length; r--;) i[r] = arguments[r];
      s.off(e, a), a.f7proxy && delete a.f7proxy, t.apply(s, i);
    }
    return a.f7proxy = t, s.on(e, a, i);
  }, l.prototype.off = function (e, t) {
    var i = this;
    return i.eventsListeners ? (e.split(' ').forEach(function (e) {
      void 0 === t ? i.eventsListeners[e] = [] : i.eventsListeners[e] && i.eventsListeners[e].length && i.eventsListeners[e].forEach(function (s, a) {
        (s === t || s.f7proxy && s.f7proxy === t) && i.eventsListeners[e].splice(a, 1);
      });
    }), i) : i;
  }, l.prototype.emit = function () {
    for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
    var i;
    var s;
    var a;
    var r = this;
    if (!r.eventsListeners) return r;
    typeof e[0] === 'string' || Array.isArray(e[0]) ? (i = e[0], s = e.slice(1, e.length), a = r) : (i = e[0].events, s = e[0].data, a = e[0].context || r);
    var n = Array.isArray(i) ? i : i.split(' ');
    return n.forEach(function (e) {
      if (r.eventsListeners && r.eventsListeners[e]) {
        var _t14 = [];
        r.eventsListeners[e].forEach(function (e) {
          _t14.push(e);
        }), _t14.forEach(function (e) {
          e.apply(a, s);
        });
      }
    }), r;
  }, l.prototype.useModulesParams = function (e) {
    var t = this;
    t.modules && Object.keys(t.modules).forEach(function (i) {
      var s = t.modules[i];
      s.params && n.extend(e, s.params);
    });
  }, l.prototype.useModules = function (e) {
    void 0 === e && (e = {});
    var t = this;
    t.modules && Object.keys(t.modules).forEach(function (i) {
      var s = t.modules[i];
      var a = e[i] || {};
      s.instance && Object.keys(s.instance).forEach(function (e) {
        var i = s.instance[e];
        t[e] = typeof i === 'function' ? i.bind(t) : i;
      }), s.on && t.on && Object.keys(s.on).forEach(function (e) {
        t.on(e, s.on[e]);
      }), s.create && s.create.bind(t)(a);
    });
  }, d.components.set = function (e) {
    this.use && this.use(e);
  }, l.installModule = function (e) {
    for (var t = [], i = arguments.length - 1; i-- > 0;) t[i] = arguments[i + 1];
    var s = this;
    s.prototype.modules || (s.prototype.modules = {});
    var a = e.name || "".concat(Object.keys(s.prototype.modules).length, "_").concat(n.now());
    return s.prototype.modules[a] = e, e.proto && Object.keys(e.proto).forEach(function (t) {
      s.prototype[t] = e.proto[t];
    }), e["static"] && Object.keys(e["static"]).forEach(function (t) {
      s[t] = e["static"][t];
    }), e.install && e.install.apply(s, t), s;
  }, l.use = function (e) {
    for (var t = [], i = arguments.length - 1; i-- > 0;) t[i] = arguments[i + 1];
    var s = this;
    return Array.isArray(e) ? (e.forEach(function (e) {
      return s.installModule(e);
    }), s) : s.installModule.apply(s, [e].concat(t));
  }, Object.defineProperties(l, d);
  var h = {
    updateSize: function updateSize() {
      var e;
      var t;
      var i = this.$el;
      e = void 0 !== this.params.width ? this.params.width : i[0].clientWidth, t = void 0 !== this.params.height ? this.params.height : i[0].clientHeight, e === 0 && this.isHorizontal() || t === 0 && this.isVertical() || (e = e - parseInt(i.css('padding-left'), 10) - parseInt(i.css('padding-right'), 10), t = t - parseInt(i.css('padding-top'), 10) - parseInt(i.css('padding-bottom'), 10), n.extend(this, {
        width: e,
        height: t,
        size: this.isHorizontal() ? e : t
      }));
    },
    updateSlides: function updateSlides() {
      var e = this.params;
      var i = this.$wrapperEl;
      var s = this.size;
      var a = this.rtlTranslate;
      var r = this.wrongRTL;
      var o = this.virtual && e.virtual.enabled;
      var l = o ? this.virtual.slides.length : this.slides.length;
      var d = i.children(".".concat(this.params.slideClass));
      var h = o ? this.virtual.slides.length : d.length;
      var p = [];
      var c = [];
      var u = [];
      function v(t) {
        return !e.cssMode || t !== d.length - 1;
      }
      var f = e.slidesOffsetBefore;
      typeof f === 'function' && (f = e.slidesOffsetBefore.call(this));
      var m = e.slidesOffsetAfter;
      typeof m === 'function' && (m = e.slidesOffsetAfter.call(this));
      var g = this.snapGrid.length;
      var b = this.snapGrid.length;
      var w = e.spaceBetween;
      var y = -f;
      var x = 0;
      var T = 0;
      if (void 0 !== s) {
        var _E;
        var _S;
        typeof w === 'string' && w.indexOf('%') >= 0 && (w = parseFloat(w.replace('%', '')) / 100 * s), this.virtualSize = -w, a ? d.css({
          marginLeft: '',
          marginTop: ''
        }) : d.css({
          marginRight: '',
          marginBottom: ''
        }), e.slidesPerColumn > 1 && (_E = Math.floor(h / e.slidesPerColumn) === h / this.params.slidesPerColumn ? h : Math.ceil(h / e.slidesPerColumn) * e.slidesPerColumn, e.slidesPerView !== 'auto' && e.slidesPerColumnFill === 'row' && (_E = Math.max(_E, e.slidesPerView * e.slidesPerColumn)));
        for (var C, M = e.slidesPerColumn, P = _E / M, z = Math.floor(h / e.slidesPerColumn), k = 0; k < h; k += 1) {
          _S = 0;
          var _$ = d.eq(k);
          if (e.slidesPerColumn > 1) {
            var _L = void 0;
            var _I = void 0;
            var _D = void 0;
            if (e.slidesPerColumnFill === 'row' && e.slidesPerGroup > 1) {
              var _O = Math.floor(k / (e.slidesPerGroup * e.slidesPerColumn));
              var _A = k - e.slidesPerColumn * e.slidesPerGroup * _O;
              var _G = _O === 0 ? e.slidesPerGroup : Math.min(Math.ceil((h - _O * M * e.slidesPerGroup) / M), e.slidesPerGroup);
              _L = (_I = _A - (_D = Math.floor(_A / _G)) * _G + _O * e.slidesPerGroup) + _D * _E / M, _$.css({
                '-webkit-box-ordinal-group': _L,
                '-moz-box-ordinal-group': _L,
                '-ms-flex-order': _L,
                '-webkit-order': _L,
                order: _L
              });
            } else e.slidesPerColumnFill === 'column' ? (_D = k - (_I = Math.floor(k / M)) * M, (_I > z || _I === z && _D === M - 1) && (_D += 1) >= M && (_D = 0, _I += 1)) : _I = k - (_D = Math.floor(k / P)) * P;
            _$.css("margin-".concat(this.isHorizontal() ? 'top' : 'left'), _D !== 0 && e.spaceBetween && "".concat(e.spaceBetween, "px"));
          }
          if (_$.css('display') !== 'none') {
            if (e.slidesPerView === 'auto') {
              var _H = t.getComputedStyle(_$[0], null);
              var _B = _$[0].style.transform;
              var _N = _$[0].style.webkitTransform;
              if (_B && (_$[0].style.transform = 'none'), _N && (_$[0].style.webkitTransform = 'none'), e.roundLengths) _S = this.isHorizontal() ? _$.outerWidth(!0) : _$.outerHeight(!0);else if (this.isHorizontal()) {
                var _X = parseFloat(_H.getPropertyValue('width'));
                var _V = parseFloat(_H.getPropertyValue('padding-left'));
                var _Y = parseFloat(_H.getPropertyValue('padding-right'));
                var _F = parseFloat(_H.getPropertyValue('margin-left'));
                var _W = parseFloat(_H.getPropertyValue('margin-right'));
                var _R = _H.getPropertyValue('box-sizing');
                _S = _R && _R === 'border-box' ? _X + _F + _W : _X + _V + _Y + _F + _W;
              } else {
                var _q = parseFloat(_H.getPropertyValue('height'));
                var _j = parseFloat(_H.getPropertyValue('padding-top'));
                var _K = parseFloat(_H.getPropertyValue('padding-bottom'));
                var _U = parseFloat(_H.getPropertyValue('margin-top'));
                var _2 = parseFloat(_H.getPropertyValue('margin-bottom'));
                var _Z = _H.getPropertyValue('box-sizing');
                _S = _Z && _Z === 'border-box' ? _q + _U + _2 : _q + _j + _K + _U + _2;
              }
              _B && (_$[0].style.transform = _B), _N && (_$[0].style.webkitTransform = _N), e.roundLengths && (_S = Math.floor(_S));
            } else _S = (s - (e.slidesPerView - 1) * w) / e.slidesPerView, e.roundLengths && (_S = Math.floor(_S)), d[k] && (this.isHorizontal() ? d[k].style.width = "".concat(_S, "px") : d[k].style.height = "".concat(_S, "px"));
            d[k] && (d[k].swiperSlideSize = _S), u.push(_S), e.centeredSlides ? (y = y + _S / 2 + x / 2 + w, x === 0 && k !== 0 && (y = y - s / 2 - w), k === 0 && (y = y - s / 2 - w), Math.abs(y) < 0.001 && (y = 0), e.roundLengths && (y = Math.floor(y)), T % e.slidesPerGroup == 0 && p.push(y), c.push(y)) : (e.roundLengths && (y = Math.floor(y)), (T - Math.min(this.params.slidesPerGroupSkip, T)) % this.params.slidesPerGroup == 0 && p.push(y), c.push(y), y = y + _S + w), this.virtualSize += _S + w, x = _S, T += 1;
          }
        }
        if (this.virtualSize = Math.max(this.virtualSize, s) + m, a && r && (e.effect === 'slide' || e.effect === 'coverflow') && i.css({
          width: "".concat(this.virtualSize + e.spaceBetween, "px")
        }), e.setWrapperSize && (this.isHorizontal() ? i.css({
          width: "".concat(this.virtualSize + e.spaceBetween, "px")
        }) : i.css({
          height: "".concat(this.virtualSize + e.spaceBetween, "px")
        })), e.slidesPerColumn > 1 && (this.virtualSize = (_S + e.spaceBetween) * _E, this.virtualSize = Math.ceil(this.virtualSize / e.slidesPerColumn) - e.spaceBetween, this.isHorizontal() ? i.css({
          width: "".concat(this.virtualSize + e.spaceBetween, "px")
        }) : i.css({
          height: "".concat(this.virtualSize + e.spaceBetween, "px")
        }), e.centeredSlides)) {
          C = [];
          for (var _Q = 0; _Q < p.length; _Q += 1) {
            var _J = p[_Q];
            e.roundLengths && (_J = Math.floor(_J)), p[_Q] < this.virtualSize + p[0] && C.push(_J);
          }
          p = C;
        }
        if (!e.centeredSlides) {
          C = [];
          for (var _ee = 0; _ee < p.length; _ee += 1) {
            var _te = p[_ee];
            e.roundLengths && (_te = Math.floor(_te)), p[_ee] <= this.virtualSize - s && C.push(_te);
          }
          p = C, Math.floor(this.virtualSize - s) - Math.floor(p[p.length - 1]) > 1 && p.push(this.virtualSize - s);
        }
        if (p.length === 0 && (p = [0]), e.spaceBetween !== 0 && (this.isHorizontal() ? a ? d.filter(v).css({
          marginLeft: "".concat(w, "px")
        }) : d.filter(v).css({
          marginRight: "".concat(w, "px")
        }) : d.filter(v).css({
          marginBottom: "".concat(w, "px")
        })), e.centeredSlides && e.centeredSlidesBounds) {
          var _ie = 0;
          u.forEach(function (t) {
            _ie += t + (e.spaceBetween ? e.spaceBetween : 0);
          });
          var _se = (_ie -= e.spaceBetween) - s;
          p = p.map(function (e) {
            return e < 0 ? -f : e > _se ? _se + m : e;
          });
        }
        if (e.centerInsufficientSlides) {
          var _ae = 0;
          if (u.forEach(function (t) {
            _ae += t + (e.spaceBetween ? e.spaceBetween : 0);
          }), (_ae -= e.spaceBetween) < s) {
            var _re = (s - _ae) / 2;
            p.forEach(function (e, t) {
              p[t] = e - _re;
            }), c.forEach(function (e, t) {
              c[t] = e + _re;
            });
          }
        }
        n.extend(this, {
          slides: d,
          snapGrid: p,
          slidesGrid: c,
          slidesSizesGrid: u
        }), h !== l && this.emit('slidesLengthChange'), p.length !== g && (this.params.watchOverflow && this.checkOverflow(), this.emit('snapGridLengthChange')), c.length !== b && this.emit('slidesGridLengthChange'), (e.watchSlidesProgress || e.watchSlidesVisibility) && this.updateSlidesOffset();
      }
    },
    updateAutoHeight: function updateAutoHeight(e) {
      var t;
      var i = [];
      var s = 0;
      if (typeof e === 'number' ? this.setTransition(e) : !0 === e && this.setTransition(this.params.speed), this.params.slidesPerView !== 'auto' && this.params.slidesPerView > 1) {
        if (this.params.centeredSlides) i.push.apply(i, this.visibleSlides);else for (t = 0; t < Math.ceil(this.params.slidesPerView); t += 1) {
          var _a9 = this.activeIndex + t;
          if (_a9 > this.slides.length) break;
          i.push(this.slides.eq(_a9)[0]);
        }
      } else i.push(this.slides.eq(this.activeIndex)[0]);
      for (t = 0; t < i.length; t += 1) if (void 0 !== i[t]) {
        var _r11 = i[t].offsetHeight;
        s = _r11 > s ? _r11 : s;
      }
      s && this.$wrapperEl.css('height', "".concat(s, "px"));
    },
    updateSlidesOffset: function updateSlidesOffset() {
      for (var _e2 = this.slides, _t15 = 0; _t15 < _e2.length; _t15 += 1) _e2[_t15].swiperSlideOffset = this.isHorizontal() ? _e2[_t15].offsetLeft : _e2[_t15].offsetTop;
    },
    updateSlidesProgress: function updateSlidesProgress(e) {
      void 0 === e && (e = this && this.translate || 0);
      var t = this.params;
      var i = this.slides;
      var a = this.rtlTranslate;
      if (i.length !== 0) {
        void 0 === i[0].swiperSlideOffset && this.updateSlidesOffset();
        var _r12 = -e;
        a && (_r12 = e), i.removeClass(t.slideVisibleClass), this.visibleSlidesIndexes = [], this.visibleSlides = [];
        for (var _n5 = 0; _n5 < i.length; _n5 += 1) {
          var _o9 = i[_n5];
          var _l7 = (_r12 + (t.centeredSlides ? this.minTranslate() : 0) - _o9.swiperSlideOffset) / (_o9.swiperSlideSize + t.spaceBetween);
          if (t.watchSlidesVisibility || t.centeredSlides && t.autoHeight) {
            var _d5 = -(_r12 - _o9.swiperSlideOffset);
            var _h5 = _d5 + this.slidesSizesGrid[_n5];
            (_d5 >= 0 && _d5 < this.size - 1 || _h5 > 1 && _h5 <= this.size || _d5 <= 0 && _h5 >= this.size) && (this.visibleSlides.push(_o9), this.visibleSlidesIndexes.push(_n5), i.eq(_n5).addClass(t.slideVisibleClass));
          }
          _o9.progress = a ? -_l7 : _l7;
        }
        this.visibleSlides = s(this.visibleSlides);
      }
    },
    updateProgress: function updateProgress(e) {
      if (void 0 === e) {
        var _t16 = this.rtlTranslate ? -1 : 1;
        e = this && this.translate && this.translate * _t16 || 0;
      }
      var i = this.params;
      var s = this.maxTranslate() - this.minTranslate();
      var a = this.progress;
      var r = this.isBeginning;
      var o = this.isEnd;
      var l = r;
      var d = o;
      s === 0 ? (a = 0, r = !0, o = !0) : (r = (a = (e - this.minTranslate()) / s) <= 0, o = a >= 1), n.extend(this, {
        progress: a,
        isBeginning: r,
        isEnd: o
      }), (i.watchSlidesProgress || i.watchSlidesVisibility || i.centeredSlides && i.autoHeight) && this.updateSlidesProgress(e), r && !l && this.emit('reachBeginning toEdge'), o && !d && this.emit('reachEnd toEdge'), (l && !r || d && !o) && this.emit('fromEdge'), this.emit('progress', a);
    },
    updateSlidesClasses: function updateSlidesClasses() {
      var e;
      var t = this.slides;
      var i = this.params;
      var s = this.$wrapperEl;
      var a = this.activeIndex;
      var r = this.realIndex;
      var n = this.virtual && i.virtual.enabled;
      t.removeClass("".concat(i.slideActiveClass, " ").concat(i.slideNextClass, " ").concat(i.slidePrevClass, " ").concat(i.slideDuplicateActiveClass, " ").concat(i.slideDuplicateNextClass, " ").concat(i.slideDuplicatePrevClass)), (e = n ? this.$wrapperEl.find(".".concat(i.slideClass, "[data-swiper-slide-index=\"").concat(a, "\"]")) : t.eq(a)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children(".".concat(i.slideClass, ":not(.").concat(i.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(r, "\"]")).addClass(i.slideDuplicateActiveClass) : s.children(".".concat(i.slideClass, ".").concat(i.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(r, "\"]")).addClass(i.slideDuplicateActiveClass));
      var o = e.nextAll(".".concat(i.slideClass)).eq(0).addClass(i.slideNextClass);
      i.loop && o.length === 0 && (o = t.eq(0)).addClass(i.slideNextClass);
      var l = e.prevAll(".".concat(i.slideClass)).eq(0).addClass(i.slidePrevClass);
      i.loop && l.length === 0 && (l = t.eq(-1)).addClass(i.slidePrevClass), i.loop && (o.hasClass(i.slideDuplicateClass) ? s.children(".".concat(i.slideClass, ":not(.").concat(i.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(o.attr('data-swiper-slide-index'), "\"]")).addClass(i.slideDuplicateNextClass) : s.children(".".concat(i.slideClass, ".").concat(i.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(o.attr('data-swiper-slide-index'), "\"]")).addClass(i.slideDuplicateNextClass), l.hasClass(i.slideDuplicateClass) ? s.children(".".concat(i.slideClass, ":not(.").concat(i.slideDuplicateClass, ")[data-swiper-slide-index=\"").concat(l.attr('data-swiper-slide-index'), "\"]")).addClass(i.slideDuplicatePrevClass) : s.children(".".concat(i.slideClass, ".").concat(i.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(l.attr('data-swiper-slide-index'), "\"]")).addClass(i.slideDuplicatePrevClass));
    },
    updateActiveIndex: function updateActiveIndex(e) {
      var t;
      var i = this.rtlTranslate ? this.translate : -this.translate;
      var s = this.slidesGrid;
      var a = this.snapGrid;
      var r = this.params;
      var o = this.activeIndex;
      var l = this.realIndex;
      var d = this.snapIndex;
      var h = e;
      if (void 0 === h) {
        for (var _p2 = 0; _p2 < s.length; _p2 += 1) void 0 !== s[_p2 + 1] ? i >= s[_p2] && i < s[_p2 + 1] - (s[_p2 + 1] - s[_p2]) / 2 ? h = _p2 : i >= s[_p2] && i < s[_p2 + 1] && (h = _p2 + 1) : i >= s[_p2] && (h = _p2);
        r.normalizeSlideIndex && (h < 0 || void 0 === h) && (h = 0);
      }
      if (a.indexOf(i) >= 0) t = a.indexOf(i);else {
        var _c2 = Math.min(r.slidesPerGroupSkip, h);
        t = _c2 + Math.floor((h - _c2) / r.slidesPerGroup);
      }
      if (t >= a.length && (t = a.length - 1), h !== o) {
        var _u3 = parseInt(this.slides.eq(h).attr('data-swiper-slide-index') || h, 10);
        n.extend(this, {
          snapIndex: t,
          realIndex: _u3,
          previousIndex: o,
          activeIndex: h
        }), this.emit('activeIndexChange'), this.emit('snapIndexChange'), l !== _u3 && this.emit('realIndexChange'), (this.initialized || this.runCallbacksOnInit) && this.emit('slideChange');
      } else t !== d && (this.snapIndex = t, this.emit('snapIndexChange'));
    },
    updateClickedSlide: function updateClickedSlide(e) {
      var t = this.params;
      var i = s(e.target).closest(".".concat(t.slideClass))[0];
      var a = !1;
      if (i) for (var _r13 = 0; _r13 < this.slides.length; _r13 += 1) this.slides[_r13] === i && (a = !0);
      if (!i || !a) return this.clickedSlide = void 0, void (this.clickedIndex = void 0);
      this.clickedSlide = i, this.virtual && this.params.virtual.enabled ? this.clickedIndex = parseInt(s(i).attr('data-swiper-slide-index'), 10) : this.clickedIndex = s(i).index(), t.slideToClickedSlide && void 0 !== this.clickedIndex && this.clickedIndex !== this.activeIndex && this.slideToClickedSlide();
    }
  };
  var p = {
    getTranslate: function getTranslate(e) {
      void 0 === e && (e = this.isHorizontal() ? 'x' : 'y');
      var t = this.params;
      var i = this.rtlTranslate;
      var s = this.translate;
      var a = this.$wrapperEl;
      if (t.virtualTranslate) return i ? -s : s;
      if (t.cssMode) return s;
      var r = n.getTranslate(a[0], e);
      return i && (r = -r), r || 0;
    },
    setTranslate: function setTranslate(e, t) {
      var i = this.rtlTranslate;
      var s = this.params;
      var a = this.$wrapperEl;
      var r = this.wrapperEl;
      var n = this.progress;
      var o = 0;
      var l = 0;
      this.isHorizontal() ? o = i ? -e : e : l = e, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), s.cssMode ? r[this.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = this.isHorizontal() ? -o : -l : s.virtualTranslate || a.transform("translate3d(".concat(o, "px, ").concat(l, "px, 0px)")), this.previousTranslate = this.translate, this.translate = this.isHorizontal() ? o : l;
      var d = this.maxTranslate() - this.minTranslate();
      (d === 0 ? 0 : (e - this.minTranslate()) / d) !== n && this.updateProgress(e), this.emit('setTranslate', this.translate, t);
    },
    minTranslate: function minTranslate() {
      return -this.snapGrid[0];
    },
    maxTranslate: function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    },
    translateTo: function translateTo(e, t, i, s, a) {
      var r;
      void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0), void 0 === s && (s = !0);
      var n = this;
      var o = n.params;
      var l = n.wrapperEl;
      if (n.animating && o.preventInteractionOnTransition) return !1;
      var d;
      var h = n.minTranslate();
      var p = n.maxTranslate();
      if (d = s && e > h ? h : s && e < p ? p : e, n.updateProgress(d), o.cssMode) {
        var _c3 = n.isHorizontal();
        return t === 0 ? l[_c3 ? 'scrollLeft' : 'scrollTop'] = -d : l.scrollTo ? l.scrollTo(((r = {})[_c3 ? 'left' : 'top'] = -d, r.behavior = 'smooth', r)) : l[_c3 ? 'scrollLeft' : 'scrollTop'] = -d, !0;
      }
      return t === 0 ? (n.setTransition(0), n.setTranslate(d), i && (n.emit('beforeTransitionStart', t, a), n.emit('transitionEnd'))) : (n.setTransition(t), n.setTranslate(d), i && (n.emit('beforeTransitionStart', t, a), n.emit('transitionStart')), n.animating || (n.animating = !0, n.onTranslateToWrapperTransitionEnd || (n.onTranslateToWrapperTransitionEnd = function (e) {
        n && !n.destroyed && e.target === this && (n.$wrapperEl[0].removeEventListener('transitionend', n.onTranslateToWrapperTransitionEnd), n.$wrapperEl[0].removeEventListener('webkitTransitionEnd', n.onTranslateToWrapperTransitionEnd), n.onTranslateToWrapperTransitionEnd = null, delete n.onTranslateToWrapperTransitionEnd, i && n.emit('transitionEnd'));
      }), n.$wrapperEl[0].addEventListener('transitionend', n.onTranslateToWrapperTransitionEnd), n.$wrapperEl[0].addEventListener('webkitTransitionEnd', n.onTranslateToWrapperTransitionEnd))), !0;
    }
  };
  var c = {
    setTransition: function setTransition(e, t) {
      this.params.cssMode || this.$wrapperEl.transition(e), this.emit('setTransition', e, t);
    },
    transitionStart: function transitionStart(e, t) {
      void 0 === e && (e = !0);
      var i = this.activeIndex;
      var s = this.params;
      var a = this.previousIndex;
      if (!s.cssMode) {
        s.autoHeight && this.updateAutoHeight();
        var _r14 = t;
        if (_r14 || (_r14 = i > a ? 'next' : i < a ? 'prev' : 'reset'), this.emit('transitionStart'), e && i !== a) {
          if (_r14 === 'reset') return void this.emit('slideResetTransitionStart');
          this.emit('slideChangeTransitionStart'), _r14 === 'next' ? this.emit('slideNextTransitionStart') : this.emit('slidePrevTransitionStart');
        }
      }
    },
    transitionEnd: function transitionEnd(e, t) {
      void 0 === e && (e = !0);
      var i = this.activeIndex;
      var s = this.previousIndex;
      var a = this.params;
      if (this.animating = !1, !a.cssMode) {
        this.setTransition(0);
        var _r15 = t;
        if (_r15 || (_r15 = i > s ? 'next' : i < s ? 'prev' : 'reset'), this.emit('transitionEnd'), e && i !== s) {
          if (_r15 === 'reset') return void this.emit('slideResetTransitionEnd');
          this.emit('slideChangeTransitionEnd'), _r15 === 'next' ? this.emit('slideNextTransitionEnd') : this.emit('slidePrevTransitionEnd');
        }
      }
    }
  };
  var u = {
    slideTo: function slideTo(e, t, i, s) {
      var a;
      void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0);
      var r = this;
      var n = e;
      n < 0 && (n = 0);
      var o = r.params;
      var l = r.snapGrid;
      var d = r.slidesGrid;
      var h = r.previousIndex;
      var p = r.activeIndex;
      var c = r.rtlTranslate;
      var u = r.wrapperEl;
      if (r.animating && o.preventInteractionOnTransition) return !1;
      var v = Math.min(r.params.slidesPerGroupSkip, n);
      var f = v + Math.floor((n - v) / r.params.slidesPerGroup);
      f >= l.length && (f = l.length - 1), (p || o.initialSlide || 0) === (h || 0) && i && r.emit('beforeSlideChangeStart');
      var m;
      var g = -l[f];
      if (r.updateProgress(g), o.normalizeSlideIndex) for (var _b = 0; _b < d.length; _b += 1) -Math.floor(100 * g) >= Math.floor(100 * d[_b]) && (n = _b);
      if (r.initialized && n !== p) {
        if (!r.allowSlideNext && g < r.translate && g < r.minTranslate()) return !1;
        if (!r.allowSlidePrev && g > r.translate && g > r.maxTranslate() && (p || 0) !== n) return !1;
      }
      if (m = n > p ? 'next' : n < p ? 'prev' : 'reset', c && -g === r.translate || !c && g === r.translate) return r.updateActiveIndex(n), o.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), o.effect !== 'slide' && r.setTranslate(g), m !== 'reset' && (r.transitionStart(i, m), r.transitionEnd(i, m)), !1;
      if (o.cssMode) {
        var _w = r.isHorizontal();
        return t === 0 ? u[_w ? 'scrollLeft' : 'scrollTop'] = -g : u.scrollTo ? u.scrollTo(((a = {})[_w ? 'left' : 'top'] = -g, a.behavior = 'smooth', a)) : u[_w ? 'scrollLeft' : 'scrollTop'] = -g, !0;
      }
      return t === 0 ? (r.setTransition(0), r.setTranslate(g), r.updateActiveIndex(n), r.updateSlidesClasses(), r.emit('beforeTransitionStart', t, s), r.transitionStart(i, m), r.transitionEnd(i, m)) : (r.setTransition(t), r.setTranslate(g), r.updateActiveIndex(n), r.updateSlidesClasses(), r.emit('beforeTransitionStart', t, s), r.transitionStart(i, m), r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function (e) {
        r && !r.destroyed && e.target === this && (r.$wrapperEl[0].removeEventListener('transitionend', r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].removeEventListener('webkitTransitionEnd', r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(i, m));
      }), r.$wrapperEl[0].addEventListener('transitionend', r.onSlideToWrapperTransitionEnd), r.$wrapperEl[0].addEventListener('webkitTransitionEnd', r.onSlideToWrapperTransitionEnd))), !0;
    },
    slideToLoop: function slideToLoop(e, t, i, s) {
      void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === i && (i = !0);
      var a = e;
      return this.params.loop && (a += this.loopedSlides), this.slideTo(a, t, i, s);
    },
    slideNext: function slideNext(e, t, i) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
      var s = this.params;
      var a = this.animating;
      var r = this.activeIndex < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup;
      if (s.loop) {
        if (a) return !1;
        this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft;
      }
      return this.slideTo(this.activeIndex + r, e, t, i);
    },
    slidePrev: function slidePrev(e, t, i) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
      var s = this.params;
      var a = this.animating;
      var r = this.snapGrid;
      var n = this.slidesGrid;
      var o = this.rtlTranslate;
      if (s.loop) {
        if (a) return !1;
        this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft;
      }
      function l(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
      }
      var d;
      var h = l(o ? this.translate : -this.translate);
      var p = r.map(function (e) {
        return l(e);
      });
      var c = (n.map(function (e) {
        return l(e);
      }), r[p.indexOf(h)], r[p.indexOf(h) - 1]);
      return void 0 === c && s.cssMode && r.forEach(function (e) {
        !c && h >= e && (c = e);
      }), void 0 !== c && (d = n.indexOf(c)) < 0 && (d = this.activeIndex - 1), this.slideTo(d, e, t, i);
    },
    slideReset: function slideReset(e, t, i) {
      return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, i);
    },
    slideToClosest: function slideToClosest(e, t, i, s) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), void 0 === s && (s = 0.5);
      var a = this.activeIndex;
      var r = Math.min(this.params.slidesPerGroupSkip, a);
      var n = r + Math.floor((a - r) / this.params.slidesPerGroup);
      var o = this.rtlTranslate ? this.translate : -this.translate;
      if (o >= this.snapGrid[n]) {
        var _l8 = this.snapGrid[n];
        o - _l8 > (this.snapGrid[n + 1] - _l8) * s && (a += this.params.slidesPerGroup);
      } else {
        var _d6 = this.snapGrid[n - 1];
        o - _d6 <= (this.snapGrid[n] - _d6) * s && (a -= this.params.slidesPerGroup);
      }
      return a = Math.max(a, 0), a = Math.min(a, this.slidesGrid.length - 1), this.slideTo(a, e, t, i);
    },
    slideToClickedSlide: function slideToClickedSlide() {
      var e;
      var t = this;
      var i = t.params;
      var a = t.$wrapperEl;
      var r = i.slidesPerView === 'auto' ? t.slidesPerViewDynamic() : i.slidesPerView;
      var o = t.clickedIndex;
      if (i.loop) {
        if (t.animating) return;
        e = parseInt(s(t.clickedSlide).attr('data-swiper-slide-index'), 10), i.centeredSlides ? o < t.loopedSlides - r / 2 || o > t.slides.length - t.loopedSlides + r / 2 ? (t.loopFix(), o = a.children(".".concat(i.slideClass, "[data-swiper-slide-index=\"").concat(e, "\"]:not(.").concat(i.slideDuplicateClass, ")")).eq(0).index(), n.nextTick(function () {
          t.slideTo(o);
        })) : t.slideTo(o) : o > t.slides.length - r ? (t.loopFix(), o = a.children(".".concat(i.slideClass, "[data-swiper-slide-index=\"").concat(e, "\"]:not(.").concat(i.slideDuplicateClass, ")")).eq(0).index(), n.nextTick(function () {
          t.slideTo(o);
        })) : t.slideTo(o);
      } else t.slideTo(o);
    }
  };
  var v = {
    loopCreate: function loopCreate() {
      var t = this;
      var i = t.params;
      var a = t.$wrapperEl;
      a.children(".".concat(i.slideClass, ".").concat(i.slideDuplicateClass)).remove();
      var r = a.children(".".concat(i.slideClass));
      if (i.loopFillGroupWithBlank) {
        var _n6 = i.slidesPerGroup - r.length % i.slidesPerGroup;
        if (_n6 !== i.slidesPerGroup) {
          for (var _o10 = 0; _o10 < _n6; _o10 += 1) {
            var _l9 = s(e.createElement('div')).addClass("".concat(i.slideClass, " ").concat(i.slideBlankClass));
            a.append(_l9);
          }
          r = a.children(".".concat(i.slideClass));
        }
      }
      i.slidesPerView !== 'auto' || i.loopedSlides || (i.loopedSlides = r.length), t.loopedSlides = Math.ceil(parseFloat(i.loopedSlides || i.slidesPerView, 10)), t.loopedSlides += i.loopAdditionalSlides, t.loopedSlides > r.length && (t.loopedSlides = r.length);
      var d = [];
      var h = [];
      r.each(function (e, i) {
        var a = s(i);
        e < t.loopedSlides && h.push(i), e < r.length && e >= r.length - t.loopedSlides && d.push(i), a.attr('data-swiper-slide-index', e);
      });
      for (var _p3 = 0; _p3 < h.length; _p3 += 1) a.append(s(h[_p3].cloneNode(!0)).addClass(i.slideDuplicateClass));
      for (var _c4 = d.length - 1; _c4 >= 0; _c4 -= 1) a.prepend(s(d[_c4].cloneNode(!0)).addClass(i.slideDuplicateClass));
    },
    loopFix: function loopFix() {
      this.emit('beforeLoopFix');
      var e;
      var t = this.activeIndex;
      var i = this.slides;
      var s = this.loopedSlides;
      var a = this.allowSlidePrev;
      var r = this.allowSlideNext;
      var n = this.snapGrid;
      var o = this.rtlTranslate;
      this.allowSlidePrev = !0, this.allowSlideNext = !0;
      var l = -n[t] - this.getTranslate();
      if (t < s) e = i.length - 3 * s + t, e += s, this.slideTo(e, 0, !1, !0) && l !== 0 && this.setTranslate((o ? -this.translate : this.translate) - l);else if (t >= i.length - s) {
        e = -i.length + t + s, e += s, this.slideTo(e, 0, !1, !0) && l !== 0 && this.setTranslate((o ? -this.translate : this.translate) - l);
      }
      this.allowSlidePrev = a, this.allowSlideNext = r, this.emit('loopFix');
    },
    loopDestroy: function loopDestroy() {
      var e = this.$wrapperEl;
      var t = this.params;
      var i = this.slides;
      e.children(".".concat(t.slideClass, ".").concat(t.slideDuplicateClass, ",.").concat(t.slideClass, ".").concat(t.slideBlankClass)).remove(), i.removeAttr('data-swiper-slide-index');
    }
  };
  var f = {
    setGrabCursor: function setGrabCursor(e) {
      if (!(o.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked || this.params.cssMode)) {
        var _t17 = this.el;
        _t17.style.cursor = 'move', _t17.style.cursor = e ? '-webkit-grabbing' : '-webkit-grab', _t17.style.cursor = e ? '-moz-grabbin' : '-moz-grab', _t17.style.cursor = e ? 'grabbing' : 'grab';
      }
    },
    unsetGrabCursor: function unsetGrabCursor() {
      o.touch || this.params.watchOverflow && this.isLocked || this.params.cssMode || (this.el.style.cursor = '');
    }
  };
  var m;
  var g;
  var b;
  var w;
  var y;
  var x;
  var T;
  var E;
  var S;
  var C;
  var M;
  var P;
  var z;
  var k;
  var $;
  var L = {
    appendSlide: function appendSlide(e) {
      var t = this.$wrapperEl;
      var i = this.params;
      if (i.loop && this.loopDestroy(), _typeof(e) === 'object' && 'length' in e) for (var _s7 = 0; _s7 < e.length; _s7 += 1) e[_s7] && t.append(e[_s7]);else t.append(e);
      i.loop && this.loopCreate(), i.observer && o.observer || this.update();
    },
    prependSlide: function prependSlide(e) {
      var t = this.params;
      var i = this.$wrapperEl;
      var s = this.activeIndex;
      t.loop && this.loopDestroy();
      var a = s + 1;
      if (_typeof(e) === 'object' && 'length' in e) {
        for (var _r16 = 0; _r16 < e.length; _r16 += 1) e[_r16] && i.prepend(e[_r16]);
        a = s + e.length;
      } else i.prepend(e);
      t.loop && this.loopCreate(), t.observer && o.observer || this.update(), this.slideTo(a, 0, !1);
    },
    addSlide: function addSlide(e, t) {
      var i = this.$wrapperEl;
      var s = this.params;
      var a = this.activeIndex;
      s.loop && (a -= this.loopedSlides, this.loopDestroy(), this.slides = i.children(".".concat(s.slideClass)));
      var r = this.slides.length;
      if (e <= 0) this.prependSlide(t);else if (e >= r) this.appendSlide(t);else {
        for (var n = a > e ? a + 1 : a, l = [], d = r - 1; d >= e; d -= 1) {
          var _h6 = this.slides.eq(d);
          _h6.remove(), l.unshift(_h6);
        }
        if (_typeof(t) === 'object' && 'length' in t) {
          for (var _p4 = 0; _p4 < t.length; _p4 += 1) t[_p4] && i.append(t[_p4]);
          n = a > e ? a + t.length : a;
        } else i.append(t);
        for (var _c5 = 0; _c5 < l.length; _c5 += 1) i.append(l[_c5]);
        s.loop && this.loopCreate(), s.observer && o.observer || this.update(), s.loop ? this.slideTo(n + this.loopedSlides, 0, !1) : this.slideTo(n, 0, !1);
      }
    },
    removeSlide: function removeSlide(e) {
      var t = this.params;
      var i = this.$wrapperEl;
      var s = this.activeIndex;
      t.loop && (s -= this.loopedSlides, this.loopDestroy(), this.slides = i.children(".".concat(t.slideClass)));
      var a;
      var r = s;
      if (_typeof(e) === 'object' && 'length' in e) {
        for (var _n7 = 0; _n7 < e.length; _n7 += 1) a = e[_n7], this.slides[a] && this.slides.eq(a).remove(), a < r && (r -= 1);
        r = Math.max(r, 0);
      } else a = e, this.slides[a] && this.slides.eq(a).remove(), a < r && (r -= 1), r = Math.max(r, 0);
      t.loop && this.loopCreate(), t.observer && o.observer || this.update(), t.loop ? this.slideTo(r + this.loopedSlides, 0, !1) : this.slideTo(r, 0, !1);
    },
    removeAllSlides: function removeAllSlides() {
      for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
      this.removeSlide(e);
    }
  };
  var I = (m = t.navigator.platform, g = t.navigator.userAgent, b = {
    ios: !1,
    android: !1,
    androidChrome: !1,
    desktop: !1,
    iphone: !1,
    ipod: !1,
    ipad: !1,
    edge: !1,
    ie: !1,
    firefox: !1,
    macos: !1,
    windows: !1,
    cordova: !(!t.cordova && !t.phonegap),
    phonegap: !(!t.cordova && !t.phonegap),
    electron: !1
  }, w = t.screen.width, y = t.screen.height, x = g.match(/(Android);?[\s\/]+([\d.]+)?/), T = g.match(/(iPad).*OS\s([\d_]+)/), E = g.match(/(iPod)(.*OS\s([\d_]+))?/), S = !T && g.match(/(iPhone\sOS|iOS)\s([\d_]+)/), C = g.indexOf('MSIE ') >= 0 || g.indexOf('Trident/') >= 0, M = g.indexOf('Edge/') >= 0, P = g.indexOf('Gecko/') >= 0 && g.indexOf('Firefox/') >= 0, z = m === 'Win32', k = g.toLowerCase().indexOf('electron') >= 0, $ = m === 'MacIntel', !T && $ && o.touch && (w === 1024 && y === 1366 || w === 834 && y === 1194 || w === 834 && y === 1112 || w === 768 && y === 1024) && (T = g.match(/(Version)\/([\d.]+)/), $ = !1), b.ie = C, b.edge = M, b.firefox = P, x && !z && (b.os = 'android', b.osVersion = x[2], b.android = !0, b.androidChrome = g.toLowerCase().indexOf('chrome') >= 0), (T || S || E) && (b.os = 'ios', b.ios = !0), S && !E && (b.osVersion = S[2].replace(/_/g, '.'), b.iphone = !0), T && (b.osVersion = T[2].replace(/_/g, '.'), b.ipad = !0), E && (b.osVersion = E[3] ? E[3].replace(/_/g, '.') : null, b.ipod = !0), b.ios && b.osVersion && g.indexOf('Version/') >= 0 && b.osVersion.split('.')[0] === '10' && (b.osVersion = g.toLowerCase().split('version/')[1].split(' ')[0]), b.webView = !(!(S || T || E) || !g.match(/.*AppleWebKit(?!.*Safari)/i) && !t.navigator.standalone) || t.matchMedia && t.matchMedia('(display-mode: standalone)').matches, b.webview = b.webView, b.standalone = b.webView, b.desktop = !(b.ios || b.android) || k, b.desktop && (b.electron = k, b.macos = $, b.windows = z, b.macos && (b.os = 'macos'), b.windows && (b.os = 'windows')), b.pixelRatio = t.devicePixelRatio || 1, b);
  function D(i) {
    var a = this.touchEventsData;
    var r = this.params;
    var o = this.touches;
    if (!this.animating || !r.preventInteractionOnTransition) {
      var _l10 = i;
      _l10.originalEvent && (_l10 = _l10.originalEvent);
      var _d7 = s(_l10.target);
      if ((r.touchEventsTarget !== 'wrapper' || _d7.closest(this.wrapperEl).length) && (a.isTouchEvent = _l10.type === 'touchstart', (a.isTouchEvent || !('which' in _l10) || _l10.which !== 3) && !(!a.isTouchEvent && 'button' in _l10 && _l10.button > 0 || a.isTouched && a.isMoved))) {
        if (r.noSwiping && _d7.closest(r.noSwipingSelector ? r.noSwipingSelector : ".".concat(r.noSwipingClass))[0]) this.allowClick = !0;else if (!r.swipeHandler || _d7.closest(r.swipeHandler)[0]) {
          o.currentX = _l10.type === 'touchstart' ? _l10.targetTouches[0].pageX : _l10.pageX, o.currentY = _l10.type === 'touchstart' ? _l10.targetTouches[0].pageY : _l10.pageY;
          var _h7 = o.currentX;
          var _p5 = o.currentY;
          var _c6 = r.edgeSwipeDetection || r.iOSEdgeSwipeDetection;
          var _u4 = r.edgeSwipeThreshold || r.iOSEdgeSwipeThreshold;
          if (!_c6 || !(_h7 <= _u4 || _h7 >= t.screen.width - _u4)) {
            if (n.extend(a, {
              isTouched: !0,
              isMoved: !1,
              allowTouchCallbacks: !0,
              isScrolling: void 0,
              startMoving: void 0
            }), o.startX = _h7, o.startY = _p5, a.touchStartTime = n.now(), this.allowClick = !0, this.updateSize(), this.swipeDirection = void 0, r.threshold > 0 && (a.allowThresholdMove = !1), _l10.type !== 'touchstart') {
              var _v3 = !0;
              _d7.is(a.formElements) && (_v3 = !1), e.activeElement && s(e.activeElement).is(a.formElements) && e.activeElement !== _d7[0] && e.activeElement.blur();
              var _f2 = _v3 && this.allowTouchMove && r.touchStartPreventDefault;
              (r.touchStartForcePreventDefault || _f2) && _l10.preventDefault();
            }
            this.emit('touchStart', _l10);
          }
        }
      }
    }
  }
  function O(t) {
    var i = this.touchEventsData;
    var a = this.params;
    var r = this.touches;
    var o = this.rtlTranslate;
    var l = t;
    if (l.originalEvent && (l = l.originalEvent), i.isTouched) {
      if (!i.isTouchEvent || l.type !== 'mousemove') {
        var _d8 = l.type === 'touchmove' && l.targetTouches && (l.targetTouches[0] || l.changedTouches[0]);
        var _h8 = l.type === 'touchmove' ? _d8.pageX : l.pageX;
        var _p6 = l.type === 'touchmove' ? _d8.pageY : l.pageY;
        if (l.preventedByNestedSwiper) return r.startX = _h8, void (r.startY = _p6);
        if (!this.allowTouchMove) {
          return this.allowClick = !1, void (i.isTouched && (n.extend(r, {
            startX: _h8,
            startY: _p6,
            currentX: _h8,
            currentY: _p6
          }), i.touchStartTime = n.now()));
        }
        if (i.isTouchEvent && a.touchReleaseOnEdges && !a.loop) if (this.isVertical()) {
          if (_p6 < r.startY && this.translate <= this.maxTranslate() || _p6 > r.startY && this.translate >= this.minTranslate()) return i.isTouched = !1, void (i.isMoved = !1);
        } else if (_h8 < r.startX && this.translate <= this.maxTranslate() || _h8 > r.startX && this.translate >= this.minTranslate()) return;
        if (i.isTouchEvent && e.activeElement && l.target === e.activeElement && s(l.target).is(i.formElements)) return i.isMoved = !0, void (this.allowClick = !1);
        if (i.allowTouchCallbacks && this.emit('touchMove', l), !(l.targetTouches && l.targetTouches.length > 1)) {
          r.currentX = _h8, r.currentY = _p6;
          var _c7 = r.currentX - r.startX;
          var _u5 = r.currentY - r.startY;
          if (!(this.params.threshold && Math.sqrt(Math.pow(_c7, 2) + Math.pow(_u5, 2)) < this.params.threshold)) {
            var _v4;
            if (void 0 === i.isScrolling) this.isHorizontal() && r.currentY === r.startY || this.isVertical() && r.currentX === r.startX ? i.isScrolling = !1 : _c7 * _c7 + _u5 * _u5 >= 25 && (_v4 = 180 * Math.atan2(Math.abs(_u5), Math.abs(_c7)) / Math.PI, i.isScrolling = this.isHorizontal() ? _v4 > a.touchAngle : 90 - _v4 > a.touchAngle);
            if (i.isScrolling && this.emit('touchMoveOpposite', l), void 0 === i.startMoving && (r.currentX === r.startX && r.currentY === r.startY || (i.startMoving = !0)), i.isScrolling) i.isTouched = !1;else if (i.startMoving) {
              this.allowClick = !1, a.cssMode || l.preventDefault(), a.touchMoveStopPropagation && !a.nested && l.stopPropagation(), i.isMoved || (a.loop && this.loopFix(), i.startTranslate = this.getTranslate(), this.setTransition(0), this.animating && this.$wrapperEl.trigger('webkitTransitionEnd transitionend'), i.allowMomentumBounce = !1, !a.grabCursor || !0 !== this.allowSlideNext && !0 !== this.allowSlidePrev || this.setGrabCursor(!0), this.emit('sliderFirstMove', l)), this.emit('sliderMove', l), i.isMoved = !0;
              var _f3 = this.isHorizontal() ? _c7 : _u5;
              r.diff = _f3, _f3 *= a.touchRatio, o && (_f3 = -_f3), this.swipeDirection = _f3 > 0 ? 'prev' : 'next', i.currentTranslate = _f3 + i.startTranslate;
              var _m = !0;
              var _g = a.resistanceRatio;
              if (a.touchReleaseOnEdges && (_g = 0), _f3 > 0 && i.currentTranslate > this.minTranslate() ? (_m = !1, a.resistance && (i.currentTranslate = this.minTranslate() - 1 + Math.pow(-this.minTranslate() + i.startTranslate + _f3, _g))) : _f3 < 0 && i.currentTranslate < this.maxTranslate() && (_m = !1, a.resistance && (i.currentTranslate = this.maxTranslate() + 1 - Math.pow(this.maxTranslate() - i.startTranslate - _f3, _g))), _m && (l.preventedByNestedSwiper = !0), !this.allowSlideNext && this.swipeDirection === 'next' && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !this.allowSlidePrev && this.swipeDirection === 'prev' && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), a.threshold > 0) {
                if (!(Math.abs(_f3) > a.threshold || i.allowThresholdMove)) return void (i.currentTranslate = i.startTranslate);
                if (!i.allowThresholdMove) return i.allowThresholdMove = !0, r.startX = r.currentX, r.startY = r.currentY, i.currentTranslate = i.startTranslate, void (r.diff = this.isHorizontal() ? r.currentX - r.startX : r.currentY - r.startY);
              }
              a.followFinger && !a.cssMode && ((a.freeMode || a.watchSlidesProgress || a.watchSlidesVisibility) && (this.updateActiveIndex(), this.updateSlidesClasses()), a.freeMode && (i.velocities.length === 0 && i.velocities.push({
                position: r[this.isHorizontal() ? 'startX' : 'startY'],
                time: i.touchStartTime
              }), i.velocities.push({
                position: r[this.isHorizontal() ? 'currentX' : 'currentY'],
                time: n.now()
              })), this.updateProgress(i.currentTranslate), this.setTranslate(i.currentTranslate));
            }
          }
        }
      }
    } else i.startMoving && i.isScrolling && this.emit('touchMoveOpposite', l);
  }
  function A(e) {
    var t = this;
    var i = t.touchEventsData;
    var s = t.params;
    var a = t.touches;
    var r = t.rtlTranslate;
    var o = t.$wrapperEl;
    var l = t.slidesGrid;
    var d = t.snapGrid;
    var h = e;
    if (h.originalEvent && (h = h.originalEvent), i.allowTouchCallbacks && t.emit('touchEnd', h), i.allowTouchCallbacks = !1, !i.isTouched) return i.isMoved && s.grabCursor && t.setGrabCursor(!1), i.isMoved = !1, void (i.startMoving = !1);
    s.grabCursor && i.isMoved && i.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
    var p;
    var c = n.now();
    var u = c - i.touchStartTime;
    if (t.allowClick && (t.updateClickedSlide(h), t.emit('tap click', h), u < 300 && c - i.lastClickTime < 300 && t.emit('doubleTap doubleClick', h)), i.lastClickTime = n.now(), n.nextTick(function () {
      t.destroyed || (t.allowClick = !0);
    }), !i.isTouched || !i.isMoved || !t.swipeDirection || a.diff === 0 || i.currentTranslate === i.startTranslate) return i.isTouched = !1, i.isMoved = !1, void (i.startMoving = !1);
    if (i.isTouched = !1, i.isMoved = !1, i.startMoving = !1, p = s.followFinger ? r ? t.translate : -t.translate : -i.currentTranslate, !s.cssMode) if (s.freeMode) {
      if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
      if (p > -t.maxTranslate()) return void (t.slides.length < d.length ? t.slideTo(d.length - 1) : t.slideTo(t.slides.length - 1));
      if (s.freeModeMomentum) {
        if (i.velocities.length > 1) {
          var _v5 = i.velocities.pop();
          var _f4 = i.velocities.pop();
          var _m2 = _v5.position - _f4.position;
          var _g2 = _v5.time - _f4.time;
          t.velocity = _m2 / _g2, t.velocity /= 2, Math.abs(t.velocity) < s.freeModeMinimumVelocity && (t.velocity = 0), (_g2 > 150 || n.now() - _v5.time > 300) && (t.velocity = 0);
        } else t.velocity = 0;
        t.velocity *= s.freeModeMomentumVelocityRatio, i.velocities.length = 0;
        var _b2 = 1e3 * s.freeModeMomentumRatio;
        var _w2 = t.velocity * _b2;
        var _y = t.translate + _w2;
        r && (_y = -_y);
        var _x;
        var _T;
        var _E2 = !1;
        var _S2 = 20 * Math.abs(t.velocity) * s.freeModeMomentumBounceRatio;
        if (_y < t.maxTranslate()) s.freeModeMomentumBounce ? (_y + t.maxTranslate() < -_S2 && (_y = t.maxTranslate() - _S2), _x = t.maxTranslate(), _E2 = !0, i.allowMomentumBounce = !0) : _y = t.maxTranslate(), s.loop && s.centeredSlides && (_T = !0);else if (_y > t.minTranslate()) s.freeModeMomentumBounce ? (_y - t.minTranslate() > _S2 && (_y = t.minTranslate() + _S2), _x = t.minTranslate(), _E2 = !0, i.allowMomentumBounce = !0) : _y = t.minTranslate(), s.loop && s.centeredSlides && (_T = !0);else if (s.freeModeSticky) {
          for (var C, M = 0; M < d.length; M += 1) if (d[M] > -_y) {
            C = M;
            break;
          }
          _y = -(_y = Math.abs(d[C] - _y) < Math.abs(d[C - 1] - _y) || t.swipeDirection === 'next' ? d[C] : d[C - 1]);
        }
        if (_T && t.once('transitionEnd', function () {
          t.loopFix();
        }), t.velocity !== 0) {
          if (_b2 = r ? Math.abs((-_y - t.translate) / t.velocity) : Math.abs((_y - t.translate) / t.velocity), s.freeModeSticky) {
            var _P = Math.abs((r ? -_y : _y) - t.translate);
            var _z = t.slidesSizesGrid[t.activeIndex];
            _b2 = _P < _z ? s.speed : _P < 2 * _z ? 1.5 * s.speed : 2.5 * s.speed;
          }
        } else if (s.freeModeSticky) return void t.slideToClosest();
        s.freeModeMomentumBounce && _E2 ? (t.updateProgress(_x), t.setTransition(_b2), t.setTranslate(_y), t.transitionStart(!0, t.swipeDirection), t.animating = !0, o.transitionEnd(function () {
          t && !t.destroyed && i.allowMomentumBounce && (t.emit('momentumBounce'), t.setTransition(s.speed), t.setTranslate(_x), o.transitionEnd(function () {
            t && !t.destroyed && t.transitionEnd();
          }));
        })) : t.velocity ? (t.updateProgress(_y), t.setTransition(_b2), t.setTranslate(_y), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, o.transitionEnd(function () {
          t && !t.destroyed && t.transitionEnd();
        }))) : t.updateProgress(_y), t.updateActiveIndex(), t.updateSlidesClasses();
      } else if (s.freeModeSticky) return void t.slideToClosest();
      (!s.freeModeMomentum || u >= s.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
    } else {
      for (var k = 0, $ = t.slidesSizesGrid[0], L = 0; L < l.length; L += L < s.slidesPerGroupSkip ? 1 : s.slidesPerGroup) {
        var _I2 = L < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
        void 0 !== l[L + _I2] ? p >= l[L] && p < l[L + _I2] && (k = L, $ = l[L + _I2] - l[L]) : p >= l[L] && (k = L, $ = l[l.length - 1] - l[l.length - 2]);
      }
      var _D2 = (p - l[k]) / $;
      var _O2 = k < s.slidesPerGroupSkip - 1 ? 1 : s.slidesPerGroup;
      if (u > s.longSwipesMs) {
        if (!s.longSwipes) return void t.slideTo(t.activeIndex);
        t.swipeDirection === 'next' && (_D2 >= s.longSwipesRatio ? t.slideTo(k + _O2) : t.slideTo(k)), t.swipeDirection === 'prev' && (_D2 > 1 - s.longSwipesRatio ? t.slideTo(k + _O2) : t.slideTo(k));
      } else {
        if (!s.shortSwipes) return void t.slideTo(t.activeIndex);
        t.navigation && (h.target === t.navigation.nextEl || h.target === t.navigation.prevEl) ? h.target === t.navigation.nextEl ? t.slideTo(k + _O2) : t.slideTo(k) : (t.swipeDirection === 'next' && t.slideTo(k + _O2), t.swipeDirection === 'prev' && t.slideTo(k));
      }
    }
  }
  function G() {
    var e = this.params;
    var t = this.el;
    if (!t || t.offsetWidth !== 0) {
      e.breakpoints && this.setBreakpoint();
      var _i9 = this.allowSlideNext;
      var _s8 = this.allowSlidePrev;
      var _a10 = this.snapGrid;
      this.allowSlideNext = !0, this.allowSlidePrev = !0, this.updateSize(), this.updateSlides(), this.updateSlidesClasses(), (e.slidesPerView === 'auto' || e.slidesPerView > 1) && this.isEnd && !this.params.centeredSlides ? this.slideTo(this.slides.length - 1, 0, !1, !0) : this.slideTo(this.activeIndex, 0, !1, !0), this.autoplay && this.autoplay.running && this.autoplay.paused && this.autoplay.run(), this.allowSlidePrev = _s8, this.allowSlideNext = _i9, this.params.watchOverflow && _a10 !== this.snapGrid && this.checkOverflow();
    }
  }
  function H(e) {
    this.allowClick || (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
  }
  function B() {
    var e = this.wrapperEl;
    this.previousTranslate = this.translate, this.translate = this.isHorizontal() ? -e.scrollLeft : -e.scrollTop, this.translate === -0 && (this.translate = 0), this.updateActiveIndex(), this.updateSlidesClasses();
    var t = this.maxTranslate() - this.minTranslate();
    (t === 0 ? 0 : (this.translate - this.minTranslate()) / t) !== this.progress && this.updateProgress(this.translate), this.emit('setTranslate', this.translate, !1);
  }
  var N = !1;
  function X() {}
  var V = {
    init: !0,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    preventInteractionOnTransition: !1,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: !0,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: !1,
    freeModeMinimumVelocity: 0.02,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: 'slide',
    breakpoints: void 0,
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !1,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 0,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: 0.85,
    watchSlidesProgress: !1,
    watchSlidesVisibility: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    preloadImages: !0,
    updateOnImagesReady: !0,
    loop: !1,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    passiveListeners: !0,
    containerModifierClass: 'swiper-container-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    runCallbacksOnInit: !0
  };
  var Y = {
    update: h,
    translate: p,
    transition: c,
    slide: u,
    loop: v,
    grabCursor: f,
    manipulation: L,
    events: {
      attachEvents: function attachEvents() {
        var t = this.params;
        var i = this.touchEvents;
        var s = this.el;
        var a = this.wrapperEl;
        this.onTouchStart = D.bind(this), this.onTouchMove = O.bind(this), this.onTouchEnd = A.bind(this), t.cssMode && (this.onScroll = B.bind(this)), this.onClick = H.bind(this);
        var r = !!t.nested;
        if (!o.touch && o.pointerEvents) s.addEventListener(i.start, this.onTouchStart, !1), e.addEventListener(i.move, this.onTouchMove, r), e.addEventListener(i.end, this.onTouchEnd, !1);else {
          if (o.touch) {
            var _n8 = !(i.start !== 'touchstart' || !o.passiveListener || !t.passiveListeners) && {
              passive: !0,
              capture: !1
            };
            s.addEventListener(i.start, this.onTouchStart, _n8), s.addEventListener(i.move, this.onTouchMove, o.passiveListener ? {
              passive: !1,
              capture: r
            } : r), s.addEventListener(i.end, this.onTouchEnd, _n8), i.cancel && s.addEventListener(i.cancel, this.onTouchEnd, _n8), N || (e.addEventListener('touchstart', X), N = !0);
          }
          (t.simulateTouch && !I.ios && !I.android || t.simulateTouch && !o.touch && I.ios) && (s.addEventListener('mousedown', this.onTouchStart, !1), e.addEventListener('mousemove', this.onTouchMove, r), e.addEventListener('mouseup', this.onTouchEnd, !1));
        }
        (t.preventClicks || t.preventClicksPropagation) && s.addEventListener('click', this.onClick, !0), t.cssMode && a.addEventListener('scroll', this.onScroll), t.updateOnWindowResize ? this.on(I.ios || I.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', G, !0) : this.on('observerUpdate', G, !0);
      },
      detachEvents: function detachEvents() {
        var t = this.params;
        var i = this.touchEvents;
        var s = this.el;
        var a = this.wrapperEl;
        var r = !!t.nested;
        if (!o.touch && o.pointerEvents) s.removeEventListener(i.start, this.onTouchStart, !1), e.removeEventListener(i.move, this.onTouchMove, r), e.removeEventListener(i.end, this.onTouchEnd, !1);else {
          if (o.touch) {
            var _n9 = !(i.start !== 'onTouchStart' || !o.passiveListener || !t.passiveListeners) && {
              passive: !0,
              capture: !1
            };
            s.removeEventListener(i.start, this.onTouchStart, _n9), s.removeEventListener(i.move, this.onTouchMove, r), s.removeEventListener(i.end, this.onTouchEnd, _n9), i.cancel && s.removeEventListener(i.cancel, this.onTouchEnd, _n9);
          }
          (t.simulateTouch && !I.ios && !I.android || t.simulateTouch && !o.touch && I.ios) && (s.removeEventListener('mousedown', this.onTouchStart, !1), e.removeEventListener('mousemove', this.onTouchMove, r), e.removeEventListener('mouseup', this.onTouchEnd, !1));
        }
        (t.preventClicks || t.preventClicksPropagation) && s.removeEventListener('click', this.onClick, !0), t.cssMode && a.removeEventListener('scroll', this.onScroll), this.off(I.ios || I.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', G);
      }
    },
    breakpoints: {
      setBreakpoint: function setBreakpoint() {
        var e = this.activeIndex;
        var t = this.initialized;
        var i = this.loopedSlides;
        void 0 === i && (i = 0);
        var s = this.params;
        var a = this.$el;
        var r = s.breakpoints;
        if (r && (!r || Object.keys(r).length !== 0)) {
          var _o11 = this.getBreakpoint(r);
          if (_o11 && this.currentBreakpoint !== _o11) {
            var _l11 = _o11 in r ? r[_o11] : void 0;
            _l11 && ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (e) {
              var t = _l11[e];
              void 0 !== t && (_l11[e] = e !== 'slidesPerView' || t !== 'AUTO' && t !== 'auto' ? e === 'slidesPerView' ? parseFloat(t) : parseInt(t, 10) : 'auto');
            });
            var _d9 = _l11 || this.originalParams;
            var _h9 = s.slidesPerColumn > 1;
            var _p7 = _d9.slidesPerColumn > 1;
            _h9 && !_p7 ? a.removeClass("".concat(s.containerModifierClass, "multirow ").concat(s.containerModifierClass, "multirow-column")) : !_h9 && _p7 && (a.addClass("".concat(s.containerModifierClass, "multirow")), _d9.slidesPerColumnFill === 'column' && a.addClass("".concat(s.containerModifierClass, "multirow-column")));
            var _c8 = _d9.direction && _d9.direction !== s.direction;
            var _u6 = s.loop && (_d9.slidesPerView !== s.slidesPerView || _c8);
            _c8 && t && this.changeDirection(), n.extend(this.params, _d9), n.extend(this, {
              allowTouchMove: this.params.allowTouchMove,
              allowSlideNext: this.params.allowSlideNext,
              allowSlidePrev: this.params.allowSlidePrev
            }), this.currentBreakpoint = _o11, _u6 && t && (this.loopDestroy(), this.loopCreate(), this.updateSlides(), this.slideTo(e - i + this.loopedSlides, 0, !1)), this.emit('breakpoint', _d9);
          }
        }
      },
      getBreakpoint: function getBreakpoint(e) {
        if (e) {
          var _i10 = !1;
          var _s9 = Object.keys(e).map(function (e) {
            if (typeof e === 'string' && e.indexOf('@') === 0) {
              var _i11 = parseFloat(e.substr(1));
              return {
                value: t.innerHeight * _i11,
                point: e
              };
            }
            return {
              value: e,
              point: e
            };
          });
          _s9.sort(function (e, t) {
            return parseInt(e.value, 10) - parseInt(t.value, 10);
          });
          for (var _a11 = 0; _a11 < _s9.length; _a11 += 1) {
            var _r17 = _s9[_a11];
            var _n10 = _r17.point;
            _r17.value <= t.innerWidth && (_i10 = _n10);
          }
          return _i10 || 'max';
        }
      }
    },
    checkOverflow: {
      checkOverflow: function checkOverflow() {
        var e = this.params;
        var t = this.isLocked;
        var i = this.slides.length > 0 && e.slidesOffsetBefore + e.spaceBetween * (this.slides.length - 1) + this.slides[0].offsetWidth * this.slides.length;
        e.slidesOffsetBefore && e.slidesOffsetAfter && i ? this.isLocked = i <= this.size : this.isLocked = this.snapGrid.length === 1, this.allowSlideNext = !this.isLocked, this.allowSlidePrev = !this.isLocked, t !== this.isLocked && this.emit(this.isLocked ? 'lock' : 'unlock'), t && t !== this.isLocked && (this.isEnd = !1, this.navigation.update());
      }
    },
    classes: {
      addClasses: function addClasses() {
        var e = this.classNames;
        var t = this.params;
        var i = this.rtl;
        var s = this.$el;
        var a = [];
        a.push('initialized'), a.push(t.direction), t.freeMode && a.push('free-mode'), t.autoHeight && a.push('autoheight'), i && a.push('rtl'), t.slidesPerColumn > 1 && (a.push('multirow'), t.slidesPerColumnFill === 'column' && a.push('multirow-column')), I.android && a.push('android'), I.ios && a.push('ios'), t.cssMode && a.push('css-mode'), a.forEach(function (i) {
          e.push(t.containerModifierClass + i);
        }), s.addClass(e.join(' '));
      },
      removeClasses: function removeClasses() {
        var e = this.$el;
        var t = this.classNames;
        e.removeClass(t.join(' '));
      }
    },
    images: {
      loadImage: function loadImage(e, i, s, a, r, n) {
        var o;
        function l() {
          n && n();
        }
        e.complete && r ? l() : i ? ((o = new t.Image()).onload = l, o.onerror = l, a && (o.sizes = a), s && (o.srcset = s), i && (o.src = i)) : l();
      },
      preloadImages: function preloadImages() {
        var e = this;
        function t() {
          e != null && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit('imagesReady')));
        }
        e.imagesToLoad = e.$el.find('img');
        for (var _i12 = 0; _i12 < e.imagesToLoad.length; _i12 += 1) {
          var _s10 = e.imagesToLoad[_i12];
          e.loadImage(_s10, _s10.currentSrc || _s10.getAttribute('src'), _s10.srcset || _s10.getAttribute('srcset'), _s10.sizes || _s10.getAttribute('sizes'), !0, t);
        }
      }
    }
  };
  var F = {};
  var W = function (e) {
    function t() {
      for (var i, a, r, l = [], d = arguments.length; d--;) l[d] = arguments[d];
      l.length === 1 && l[0].constructor && l[0].constructor === Object ? r = l[0] : (a = (i = l)[0], r = i[1]), r || (r = {}), r = n.extend({}, r), a && !r.el && (r.el = a), e.call(this, r), Object.keys(Y).forEach(function (e) {
        Object.keys(Y[e]).forEach(function (i) {
          t.prototype[i] || (t.prototype[i] = Y[e][i]);
        });
      });
      var h = this;
      void 0 === h.modules && (h.modules = {}), Object.keys(h.modules).forEach(function (e) {
        var t = h.modules[e];
        if (t.params) {
          var _i13 = Object.keys(t.params)[0];
          var _s11 = t.params[_i13];
          if (_typeof(_s11) !== 'object' || _s11 === null) return;
          if (!(_i13 in r && 'enabled' in _s11)) return;
          !0 === r[_i13] && (r[_i13] = {
            enabled: !0
          }), _typeof(r[_i13]) !== 'object' || 'enabled' in r[_i13] || (r[_i13].enabled = !0), r[_i13] || (r[_i13] = {
            enabled: !1
          });
        }
      });
      var p = n.extend({}, V);
      h.useModulesParams(p), h.params = n.extend({}, p, F, r), h.originalParams = n.extend({}, h.params), h.passedParams = n.extend({}, r), h.$ = s;
      var c = s(h.params.el);
      if (a = c[0]) {
        if (c.length > 1) {
          var _u7 = [];
          return c.each(function (e, i) {
            var s = n.extend({}, r, {
              el: i
            });
            _u7.push(new t(s));
          }), _u7;
        }
        var _v6;
        var _f5;
        var _m3;
        return a.swiper = h, c.data('swiper', h), a && a.shadowRoot && a.shadowRoot.querySelector ? (_v6 = s(a.shadowRoot.querySelector(".".concat(h.params.wrapperClass)))).children = function (e) {
          return c.children(e);
        } : _v6 = c.children(".".concat(h.params.wrapperClass)), n.extend(h, {
          $el: c,
          el: a,
          $wrapperEl: _v6,
          wrapperEl: _v6[0],
          classNames: [],
          slides: s(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: function isHorizontal() {
            return h.params.direction === 'horizontal';
          },
          isVertical: function isVertical() {
            return h.params.direction === 'vertical';
          },
          rtl: a.dir.toLowerCase() === 'rtl' || c.css('direction') === 'rtl',
          rtlTranslate: h.params.direction === 'horizontal' && (a.dir.toLowerCase() === 'rtl' || c.css('direction') === 'rtl'),
          wrongRTL: _v6.css('display') === '-webkit-box',
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          allowSlideNext: h.params.allowSlideNext,
          allowSlidePrev: h.params.allowSlidePrev,
          touchEvents: (_f5 = ['touchstart', 'touchmove', 'touchend', 'touchcancel'], _m3 = ['mousedown', 'mousemove', 'mouseup'], o.pointerEvents && (_m3 = ['pointerdown', 'pointermove', 'pointerup']), h.touchEventsTouch = {
            start: _f5[0],
            move: _f5[1],
            end: _f5[2],
            cancel: _f5[3]
          }, h.touchEventsDesktop = {
            start: _m3[0],
            move: _m3[1],
            end: _m3[2]
          }, o.touch || !h.params.simulateTouch ? h.touchEventsTouch : h.touchEventsDesktop),
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            formElements: 'input, select, option, textarea, button, video, label',
            lastClickTime: n.now(),
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            isTouchEvent: void 0,
            startMoving: void 0
          },
          allowClick: !0,
          allowTouchMove: h.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
          },
          imagesToLoad: [],
          imagesLoaded: 0
        }), h.useModules(), h.params.init && h.init(), h;
      }
    }
    e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t;
    var i = {
      extendedDefaults: {
        configurable: !0
      },
      defaults: {
        configurable: !0
      },
      Class: {
        configurable: !0
      },
      $: {
        configurable: !0
      }
    };
    return t.prototype.slidesPerViewDynamic = function () {
      var e = this.params;
      var t = this.slides;
      var i = this.slidesGrid;
      var s = this.size;
      var a = this.activeIndex;
      var r = 1;
      if (e.centeredSlides) {
        for (var n, o = t[a].swiperSlideSize, l = a + 1; l < t.length; l += 1) t[l] && !n && (r += 1, (o += t[l].swiperSlideSize) > s && (n = !0));
        for (var _d10 = a - 1; _d10 >= 0; _d10 -= 1) t[_d10] && !n && (r += 1, (o += t[_d10].swiperSlideSize) > s && (n = !0));
      } else for (var _h10 = a + 1; _h10 < t.length; _h10 += 1) i[_h10] - i[a] < s && (r += 1);
      return r;
    }, t.prototype.update = function () {
      var e = this;
      if (e && !e.destroyed) {
        var _t18 = e.snapGrid;
        var _i14 = e.params;
        _i14.breakpoints && e.setBreakpoint(), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode ? (s(), e.params.autoHeight && e.updateAutoHeight()) : ((e.params.slidesPerView === 'auto' || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0)) || s(), _i14.watchOverflow && _t18 !== e.snapGrid && e.checkOverflow(), e.emit('update');
      }
      function s() {
        var t = e.rtlTranslate ? -1 * e.translate : e.translate;
        var i = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
        e.setTranslate(i), e.updateActiveIndex(), e.updateSlidesClasses();
      }
    }, t.prototype.changeDirection = function (e, t) {
      void 0 === t && (t = !0);
      var i = this.params.direction;
      return e || (e = i === 'horizontal' ? 'vertical' : 'horizontal'), e === i || e !== 'horizontal' && e !== 'vertical' ? this : (this.$el.removeClass("".concat(this.params.containerModifierClass).concat(i)).addClass("".concat(this.params.containerModifierClass).concat(e)), this.params.direction = e, this.slides.each(function (t, i) {
        e === 'vertical' ? i.style.width = '' : i.style.height = '';
      }), this.emit('changeDirection'), t && this.update(), this);
    }, t.prototype.init = function () {
      this.initialized || (this.emit('beforeInit'), this.params.breakpoints && this.setBreakpoint(), this.addClasses(), this.params.loop && this.loopCreate(), this.updateSize(), this.updateSlides(), this.params.watchOverflow && this.checkOverflow(), this.params.grabCursor && this.setGrabCursor(), this.params.preloadImages && this.preloadImages(), this.params.loop ? this.slideTo(this.params.initialSlide + this.loopedSlides, 0, this.params.runCallbacksOnInit) : this.slideTo(this.params.initialSlide, 0, this.params.runCallbacksOnInit), this.attachEvents(), this.initialized = !0, this.emit('init'));
    }, t.prototype.destroy = function (e, t) {
      void 0 === e && (e = !0), void 0 === t && (t = !0);
      var i = this;
      var s = i.params;
      var a = i.$el;
      var r = i.$wrapperEl;
      var o = i.slides;
      return void 0 === i.params || i.destroyed ? null : (i.emit('beforeDestroy'), i.initialized = !1, i.detachEvents(), s.loop && i.loopDestroy(), t && (i.removeClasses(), a.removeAttr('style'), r.removeAttr('style'), o && o.length && o.removeClass([s.slideVisibleClass, s.slideActiveClass, s.slideNextClass, s.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index')), i.emit('destroy'), Object.keys(i.eventsListeners).forEach(function (e) {
        i.off(e);
      }), !1 !== e && (i.$el[0].swiper = null, i.$el.data('swiper', null), n.deleteProps(i)), i.destroyed = !0, null);
    }, t.extendDefaults = function (e) {
      n.extend(F, e);
    }, i.extendedDefaults.get = function () {
      return F;
    }, i.defaults.get = function () {
      return V;
    }, i.Class.get = function () {
      return e;
    }, i.$.get = function () {
      return s;
    }, Object.defineProperties(t, i), t;
  }(l);
  var R = {
    name: 'device',
    proto: {
      device: I
    },
    "static": {
      device: I
    }
  };
  var q = {
    name: 'support',
    proto: {
      support: o
    },
    "static": {
      support: o
    }
  };
  var j = {
    isEdge: !!t.navigator.userAgent.match(/Edge/g),
    isSafari: function () {
      var e = t.navigator.userAgent.toLowerCase();
      return e.indexOf('safari') >= 0 && e.indexOf('chrome') < 0 && e.indexOf('android') < 0;
    }(),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent)
  };
  var K = {
    name: 'browser',
    proto: {
      browser: j
    },
    "static": {
      browser: j
    }
  };
  var U = {
    name: 'resize',
    create: function create() {
      var e = this;
      n.extend(e, {
        resize: {
          resizeHandler: function resizeHandler() {
            e && !e.destroyed && e.initialized && (e.emit('beforeResize'), e.emit('resize'));
          },
          orientationChangeHandler: function orientationChangeHandler() {
            e && !e.destroyed && e.initialized && e.emit('orientationchange');
          }
        }
      });
    },
    on: {
      init: function init() {
        t.addEventListener('resize', this.resize.resizeHandler), t.addEventListener('orientationchange', this.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        t.removeEventListener('resize', this.resize.resizeHandler), t.removeEventListener('orientationchange', this.resize.orientationChangeHandler);
      }
    }
  };
  var _ = {
    func: t.MutationObserver || t.WebkitMutationObserver,
    attach: function attach(e, i) {
      void 0 === i && (i = {});
      var s = this;
      var a = new (0, _.func)(function (e) {
        if (e.length !== 1) {
          var _i15 = function _i15() {
            s.emit('observerUpdate', e[0]);
          };
          t.requestAnimationFrame ? t.requestAnimationFrame(_i15) : t.setTimeout(_i15, 0);
        } else s.emit('observerUpdate', e[0]);
      });
      a.observe(e, {
        attributes: void 0 === i.attributes || i.attributes,
        childList: void 0 === i.childList || i.childList,
        characterData: void 0 === i.characterData || i.characterData
      }), s.observer.observers.push(a);
    },
    init: function init() {
      if (o.observer && this.params.observer) {
        if (this.params.observeParents) for (var _e3 = this.$el.parents(), _t19 = 0; _t19 < _e3.length; _t19 += 1) this.observer.attach(_e3[_t19]);
        this.observer.attach(this.$el[0], {
          childList: this.params.observeSlideChildren
        }), this.observer.attach(this.$wrapperEl[0], {
          attributes: !1
        });
      }
    },
    destroy: function destroy() {
      this.observer.observers.forEach(function (e) {
        e.disconnect();
      }), this.observer.observers = [];
    }
  };
  var Z = {
    name: 'observer',
    params: {
      observer: !1,
      observeParents: !1,
      observeSlideChildren: !1
    },
    create: function create() {
      n.extend(this, {
        observer: {
          init: _.init.bind(this),
          attach: _.attach.bind(this),
          destroy: _.destroy.bind(this),
          observers: []
        }
      });
    },
    on: {
      init: function init() {
        this.observer.init();
      },
      destroy: function destroy() {
        this.observer.destroy();
      }
    }
  };
  var Q = {
    update: function update(e) {
      var t = this;
      var i = t.params;
      var s = i.slidesPerView;
      var a = i.slidesPerGroup;
      var r = i.centeredSlides;
      var o = t.params.virtual;
      var l = o.addSlidesBefore;
      var d = o.addSlidesAfter;
      var h = t.virtual;
      var p = h.from;
      var c = h.to;
      var u = h.slides;
      var v = h.slidesGrid;
      var f = h.renderSlide;
      var m = h.offset;
      t.updateActiveIndex();
      var g;
      var b;
      var w;
      var y = t.activeIndex || 0;
      g = t.rtlTranslate ? 'right' : t.isHorizontal() ? 'left' : 'top', r ? (b = Math.floor(s / 2) + a + l, w = Math.floor(s / 2) + a + d) : (b = s + (a - 1) + l, w = a + d);
      var x = Math.max((y || 0) - w, 0);
      var T = Math.min((y || 0) + b, u.length - 1);
      var E = (t.slidesGrid[x] || 0) - (t.slidesGrid[0] || 0);
      function S() {
        t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load();
      }
      if (n.extend(t.virtual, {
        from: x,
        to: T,
        offset: E,
        slidesGrid: t.slidesGrid
      }), p === x && c === T && !e) return t.slidesGrid !== v && E !== m && t.slides.css(g, "".concat(E, "px")), void t.updateProgress();
      if (t.params.virtual.renderExternal) {
        return t.params.virtual.renderExternal.call(t, {
          offset: E,
          from: x,
          to: T,
          slides: function () {
            for (var e = [], t = x; t <= T; t += 1) e.push(u[t]);
            return e;
          }()
        }), void S();
      }
      var C = [];
      var M = [];
      if (e) t.$wrapperEl.find(".".concat(t.params.slideClass)).remove();else for (var _P2 = p; _P2 <= c; _P2 += 1) (_P2 < x || _P2 > T) && t.$wrapperEl.find(".".concat(t.params.slideClass, "[data-swiper-slide-index=\"").concat(_P2, "\"]")).remove();
      for (var _z2 = 0; _z2 < u.length; _z2 += 1) _z2 >= x && _z2 <= T && (void 0 === c || e ? M.push(_z2) : (_z2 > c && M.push(_z2), _z2 < p && C.push(_z2)));
      M.forEach(function (e) {
        t.$wrapperEl.append(f(u[e], e));
      }), C.sort(function (e, t) {
        return t - e;
      }).forEach(function (e) {
        t.$wrapperEl.prepend(f(u[e], e));
      }), t.$wrapperEl.children('.swiper-slide').css(g, "".concat(E, "px")), S();
    },
    renderSlide: function renderSlide(e, t) {
      var i = this.params.virtual;
      if (i.cache && this.virtual.cache[t]) return this.virtual.cache[t];
      var a = i.renderSlide ? s(i.renderSlide.call(this, e, t)) : s("<div class=\"".concat(this.params.slideClass, "\" data-swiper-slide-index=\"").concat(t, "\">").concat(e, "</div>"));
      return a.attr('data-swiper-slide-index') || a.attr('data-swiper-slide-index', t), i.cache && (this.virtual.cache[t] = a), a;
    },
    appendSlide: function appendSlide(e) {
      if (_typeof(e) === 'object' && 'length' in e) for (var _t20 = 0; _t20 < e.length; _t20 += 1) e[_t20] && this.virtual.slides.push(e[_t20]);else this.virtual.slides.push(e);
      this.virtual.update(!0);
    },
    prependSlide: function prependSlide(e) {
      var t = this.activeIndex;
      var i = t + 1;
      var s = 1;
      if (Array.isArray(e)) {
        for (var _a12 = 0; _a12 < e.length; _a12 += 1) e[_a12] && this.virtual.slides.unshift(e[_a12]);
        i = t + e.length, s = e.length;
      } else this.virtual.slides.unshift(e);
      if (this.params.virtual.cache) {
        var _r18 = this.virtual.cache;
        var _n11 = {};
        Object.keys(_r18).forEach(function (e) {
          var t = _r18[e];
          var i = t.attr('data-swiper-slide-index');
          i && t.attr('data-swiper-slide-index', parseInt(i, 10) + 1), _n11[parseInt(e, 10) + s] = t;
        }), this.virtual.cache = _n11;
      }
      this.virtual.update(!0), this.slideTo(i, 0);
    },
    removeSlide: function removeSlide(e) {
      if (e != null) {
        var _t21 = this.activeIndex;
        if (Array.isArray(e)) for (var _i16 = e.length - 1; _i16 >= 0; _i16 -= 1) this.virtual.slides.splice(e[_i16], 1), this.params.virtual.cache && delete this.virtual.cache[e[_i16]], e[_i16] < _t21 && (_t21 -= 1), _t21 = Math.max(_t21, 0);else this.virtual.slides.splice(e, 1), this.params.virtual.cache && delete this.virtual.cache[e], e < _t21 && (_t21 -= 1), _t21 = Math.max(_t21, 0);
        this.virtual.update(!0), this.slideTo(_t21, 0);
      }
    },
    removeAllSlides: function removeAllSlides() {
      this.virtual.slides = [], this.params.virtual.cache && (this.virtual.cache = {}), this.virtual.update(!0), this.slideTo(0, 0);
    }
  };
  var J = {
    name: 'virtual',
    params: {
      virtual: {
        enabled: !1,
        slides: [],
        cache: !0,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0
      }
    },
    create: function create() {
      n.extend(this, {
        virtual: {
          update: Q.update.bind(this),
          appendSlide: Q.appendSlide.bind(this),
          prependSlide: Q.prependSlide.bind(this),
          removeSlide: Q.removeSlide.bind(this),
          removeAllSlides: Q.removeAllSlides.bind(this),
          renderSlide: Q.renderSlide.bind(this),
          slides: this.params.virtual.slides,
          cache: {}
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        if (this.params.virtual.enabled) {
          this.classNames.push("".concat(this.params.containerModifierClass, "virtual"));
          var _e4 = {
            watchSlidesProgress: !0
          };
          n.extend(this.params, _e4), n.extend(this.originalParams, _e4), this.params.initialSlide || this.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        this.params.virtual.enabled && this.virtual.update();
      }
    }
  };
  var ee = {
    handle: function handle(i) {
      var s = this.rtlTranslate;
      var a = i;
      a.originalEvent && (a = a.originalEvent);
      var r = a.keyCode || a.charCode;
      if (!this.allowSlideNext && (this.isHorizontal() && r === 39 || this.isVertical() && r === 40 || r === 34)) return !1;
      if (!this.allowSlidePrev && (this.isHorizontal() && r === 37 || this.isVertical() && r === 38 || r === 33)) return !1;
      if (!(a.shiftKey || a.altKey || a.ctrlKey || a.metaKey || e.activeElement && e.activeElement.nodeName && (e.activeElement.nodeName.toLowerCase() === 'input' || e.activeElement.nodeName.toLowerCase() === 'textarea'))) {
        if (this.params.keyboard.onlyInViewport && (r === 33 || r === 34 || r === 37 || r === 39 || r === 38 || r === 40)) {
          var _n12 = !1;
          if (this.$el.parents(".".concat(this.params.slideClass)).length > 0 && this.$el.parents(".".concat(this.params.slideActiveClass)).length === 0) return;
          var _o12 = t.innerWidth;
          var _l12 = t.innerHeight;
          var _d11 = this.$el.offset();
          s && (_d11.left -= this.$el[0].scrollLeft);
          for (var _h11 = [[_d11.left, _d11.top], [_d11.left + this.width, _d11.top], [_d11.left, _d11.top + this.height], [_d11.left + this.width, _d11.top + this.height]], _p8 = 0; _p8 < _h11.length; _p8 += 1) {
            var _c9 = _h11[_p8];
            _c9[0] >= 0 && _c9[0] <= _o12 && _c9[1] >= 0 && _c9[1] <= _l12 && (_n12 = !0);
          }
          if (!_n12) return;
        }
        this.isHorizontal() ? (r !== 33 && r !== 34 && r !== 37 && r !== 39 || (a.preventDefault ? a.preventDefault() : a.returnValue = !1), (r !== 34 && r !== 39 || s) && (r !== 33 && r !== 37 || !s) || this.slideNext(), (r !== 33 && r !== 37 || s) && (r !== 34 && r !== 39 || !s) || this.slidePrev()) : (r !== 33 && r !== 34 && r !== 38 && r !== 40 || (a.preventDefault ? a.preventDefault() : a.returnValue = !1), r !== 34 && r !== 40 || this.slideNext(), r !== 33 && r !== 38 || this.slidePrev()), this.emit('keyPress', r);
      }
    },
    enable: function enable() {
      this.keyboard.enabled || (s(e).on('keydown', this.keyboard.handle), this.keyboard.enabled = !0);
    },
    disable: function disable() {
      this.keyboard.enabled && (s(e).off('keydown', this.keyboard.handle), this.keyboard.enabled = !1);
    }
  };
  var te = {
    name: 'keyboard',
    params: {
      keyboard: {
        enabled: !1,
        onlyInViewport: !0
      }
    },
    create: function create() {
      n.extend(this, {
        keyboard: {
          enabled: !1,
          enable: ee.enable.bind(this),
          disable: ee.disable.bind(this),
          handle: ee.handle.bind(this)
        }
      });
    },
    on: {
      init: function init() {
        this.params.keyboard.enabled && this.keyboard.enable();
      },
      destroy: function destroy() {
        this.keyboard.enabled && this.keyboard.disable();
      }
    }
  };
  var ie = {
    lastScrollTime: n.now(),
    lastEventBeforeSnap: void 0,
    recentWheelEvents: [],
    event: function event() {
      return t.navigator.userAgent.indexOf('firefox') > -1 ? 'DOMMouseScroll' : function () {
        var t = 'onwheel' in e;
        if (!t) {
          var _i17 = e.createElement('div');
          _i17.setAttribute('onwheel', 'return;'), t = typeof _i17.onwheel === 'function';
        }
        return !t && e.implementation && e.implementation.hasFeature && !0 !== e.implementation.hasFeature('', '') && (t = e.implementation.hasFeature('Events.wheel', '3.0')), t;
      }() ? 'wheel' : 'mousewheel';
    },
    normalize: function normalize(e) {
      var t = 0;
      var i = 0;
      var s = 0;
      var a = 0;
      return 'detail' in e && (i = e.detail), 'wheelDelta' in e && (i = -e.wheelDelta / 120), 'wheelDeltaY' in e && (i = -e.wheelDeltaY / 120), 'wheelDeltaX' in e && (t = -e.wheelDeltaX / 120), 'axis' in e && e.axis === e.HORIZONTAL_AXIS && (t = i, i = 0), s = 10 * t, a = 10 * i, 'deltaY' in e && (a = e.deltaY), 'deltaX' in e && (s = e.deltaX), e.shiftKey && !s && (s = a, a = 0), (s || a) && e.deltaMode && (e.deltaMode === 1 ? (s *= 40, a *= 40) : (s *= 800, a *= 800)), s && !t && (t = s < 1 ? -1 : 1), a && !i && (i = a < 1 ? -1 : 1), {
        spinX: t,
        spinY: i,
        pixelX: s,
        pixelY: a
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      this.mouseEntered = !0;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.mouseEntered = !1;
    },
    handle: function handle(e) {
      var t = e;
      var i = this;
      var a = i.params.mousewheel;
      i.params.cssMode && t.preventDefault();
      var r = i.$el;
      if (i.params.mousewheel.eventsTarged !== 'container' && (r = s(i.params.mousewheel.eventsTarged)), !i.mouseEntered && !r[0].contains(t.target) && !a.releaseOnEdges) return !0;
      t.originalEvent && (t = t.originalEvent);
      var o = 0;
      var l = i.rtlTranslate ? -1 : 1;
      var d = ie.normalize(t);
      if (a.forceToAxis) {
        if (i.isHorizontal()) {
          if (!(Math.abs(d.pixelX) > Math.abs(d.pixelY))) return !0;
          o = d.pixelX * l;
        } else {
          if (!(Math.abs(d.pixelY) > Math.abs(d.pixelX))) return !0;
          o = d.pixelY;
        }
      } else o = Math.abs(d.pixelX) > Math.abs(d.pixelY) ? -d.pixelX * l : -d.pixelY;
      if (o === 0) return !0;
      if (a.invert && (o = -o), i.params.freeMode) {
        var _h12 = {
          time: n.now(),
          delta: Math.abs(o),
          direction: Math.sign(o)
        };
        var _p9 = i.mousewheel.lastEventBeforeSnap;
        var _c10 = _p9 && _h12.time < _p9.time + 500 && _h12.delta <= _p9.delta && _h12.direction === _p9.direction;
        if (!_c10) {
          i.mousewheel.lastEventBeforeSnap = void 0, i.params.loop && i.loopFix();
          var _u8 = i.getTranslate() + o * a.sensitivity;
          var _v7 = i.isBeginning;
          var _f6 = i.isEnd;
          if (_u8 >= i.minTranslate() && (_u8 = i.minTranslate()), _u8 <= i.maxTranslate() && (_u8 = i.maxTranslate()), i.setTransition(0), i.setTranslate(_u8), i.updateProgress(), i.updateActiveIndex(), i.updateSlidesClasses(), (!_v7 && i.isBeginning || !_f6 && i.isEnd) && i.updateSlidesClasses(), i.params.freeModeSticky) {
            clearTimeout(i.mousewheel.timeout), i.mousewheel.timeout = void 0;
            var _m4 = i.mousewheel.recentWheelEvents;
            _m4.length >= 15 && _m4.shift();
            var _g3 = _m4.length ? _m4[_m4.length - 1] : void 0;
            var _b3 = _m4[0];
            if (_m4.push(_h12), _g3 && (_h12.delta > _g3.delta || _h12.direction !== _g3.direction)) _m4.splice(0);else if (_m4.length >= 15 && _h12.time - _b3.time < 500 && _b3.delta - _h12.delta >= 1 && _h12.delta <= 6) {
              var _w3 = o > 0 ? 0.8 : 0.2;
              i.mousewheel.lastEventBeforeSnap = _h12, _m4.splice(0), i.mousewheel.timeout = n.nextTick(function () {
                i.slideToClosest(i.params.speed, !0, void 0, _w3);
              }, 0);
            }
            i.mousewheel.timeout || (i.mousewheel.timeout = n.nextTick(function () {
              i.mousewheel.lastEventBeforeSnap = _h12, _m4.splice(0), i.slideToClosest(i.params.speed, !0, void 0, 0.5);
            }, 500));
          }
          if (_c10 || i.emit('scroll', t), i.params.autoplay && i.params.autoplayDisableOnInteraction && i.autoplay.stop(), _u8 === i.minTranslate() || _u8 === i.maxTranslate()) return !0;
        }
      } else {
        var _y2 = {
          time: n.now(),
          delta: Math.abs(o),
          direction: Math.sign(o),
          raw: e
        };
        var _x2 = i.mousewheel.recentWheelEvents;
        _x2.length >= 2 && _x2.shift();
        var _T2 = _x2.length ? _x2[_x2.length - 1] : void 0;
        if (_x2.push(_y2), _T2 ? (_y2.direction !== _T2.direction || _y2.delta > _T2.delta) && i.mousewheel.animateSlider(_y2) : i.mousewheel.animateSlider(_y2), i.mousewheel.releaseScroll(_y2)) return !0;
      }
      return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1;
    },
    animateSlider: function animateSlider(e) {
      return e.delta >= 6 && n.now() - this.mousewheel.lastScrollTime < 60 || (e.direction < 0 ? this.isEnd && !this.params.loop || this.animating || (this.slideNext(), this.emit('scroll', e.raw)) : this.isBeginning && !this.params.loop || this.animating || (this.slidePrev(), this.emit('scroll', e.raw)), this.mousewheel.lastScrollTime = new t.Date().getTime(), !1);
    },
    releaseScroll: function releaseScroll(e) {
      var t = this.params.mousewheel;
      if (e.direction < 0) {
        if (this.isEnd && !this.params.loop && t.releaseOnEdges) return !0;
      } else if (this.isBeginning && !this.params.loop && t.releaseOnEdges) return !0;
      return !1;
    },
    enable: function enable() {
      var e = ie.event();
      if (this.params.cssMode) return this.wrapperEl.removeEventListener(e, this.mousewheel.handle), !0;
      if (!e) return !1;
      if (this.mousewheel.enabled) return !1;
      var t = this.$el;
      return this.params.mousewheel.eventsTarged !== 'container' && (t = s(this.params.mousewheel.eventsTarged)), t.on('mouseenter', this.mousewheel.handleMouseEnter), t.on('mouseleave', this.mousewheel.handleMouseLeave), t.on(e, this.mousewheel.handle), this.mousewheel.enabled = !0, !0;
    },
    disable: function disable() {
      var e = ie.event();
      if (this.params.cssMode) return this.wrapperEl.addEventListener(e, this.mousewheel.handle), !0;
      if (!e) return !1;
      if (!this.mousewheel.enabled) return !1;
      var t = this.$el;
      return this.params.mousewheel.eventsTarged !== 'container' && (t = s(this.params.mousewheel.eventsTarged)), t.off(e, this.mousewheel.handle), this.mousewheel.enabled = !1, !0;
    }
  };
  var se = {
    update: function update() {
      var e = this.params.navigation;
      if (!this.params.loop) {
        var _t22 = this.navigation;
        var _i18 = _t22.$nextEl;
        var _s12 = _t22.$prevEl;
        _s12 && _s12.length > 0 && (this.isBeginning ? _s12.addClass(e.disabledClass) : _s12.removeClass(e.disabledClass), _s12[this.params.watchOverflow && this.isLocked ? 'addClass' : 'removeClass'](e.lockClass)), _i18 && _i18.length > 0 && (this.isEnd ? _i18.addClass(e.disabledClass) : _i18.removeClass(e.disabledClass), _i18[this.params.watchOverflow && this.isLocked ? 'addClass' : 'removeClass'](e.lockClass));
      }
    },
    onPrevClick: function onPrevClick(e) {
      e.preventDefault(), this.isBeginning && !this.params.loop || this.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      e.preventDefault(), this.isEnd && !this.params.loop || this.slideNext();
    },
    init: function init() {
      var e;
      var t;
      var i = this.params.navigation;
      (i.nextEl || i.prevEl) && (i.nextEl && (e = s(i.nextEl), this.params.uniqueNavElements && typeof i.nextEl === 'string' && e.length > 1 && this.$el.find(i.nextEl).length === 1 && (e = this.$el.find(i.nextEl))), i.prevEl && (t = s(i.prevEl), this.params.uniqueNavElements && typeof i.prevEl === 'string' && t.length > 1 && this.$el.find(i.prevEl).length === 1 && (t = this.$el.find(i.prevEl))), e && e.length > 0 && e.on('click', this.navigation.onNextClick), t && t.length > 0 && t.on('click', this.navigation.onPrevClick), n.extend(this.navigation, {
        $nextEl: e,
        nextEl: e && e[0],
        $prevEl: t,
        prevEl: t && t[0]
      }));
    },
    destroy: function destroy() {
      var e = this.navigation;
      var t = e.$nextEl;
      var i = e.$prevEl;
      t && t.length && (t.off('click', this.navigation.onNextClick), t.removeClass(this.params.navigation.disabledClass)), i && i.length && (i.off('click', this.navigation.onPrevClick), i.removeClass(this.params.navigation.disabledClass));
    }
  };
  var ae = {
    update: function update() {
      var e = this.rtl;
      var t = this.params.pagination;
      if (t.el && this.pagination.el && this.pagination.$el && this.pagination.$el.length !== 0) {
        var _i19;
        var _a13 = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length;
        var _r19 = this.pagination.$el;
        var _n13 = this.params.loop ? Math.ceil((_a13 - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length;
        if (this.params.loop ? ((_i19 = Math.ceil((this.activeIndex - this.loopedSlides) / this.params.slidesPerGroup)) > _a13 - 1 - 2 * this.loopedSlides && (_i19 -= _a13 - 2 * this.loopedSlides), _i19 > _n13 - 1 && (_i19 -= _n13), _i19 < 0 && this.params.paginationType !== 'bullets' && (_i19 = _n13 + _i19)) : _i19 = void 0 !== this.snapIndex ? this.snapIndex : this.activeIndex || 0, t.type === 'bullets' && this.pagination.bullets && this.pagination.bullets.length > 0) {
          var _o13;
          var _l13;
          var _d12;
          var _h13 = this.pagination.bullets;
          if (t.dynamicBullets && (this.pagination.bulletSize = _h13.eq(0)[this.isHorizontal() ? 'outerWidth' : 'outerHeight'](!0), _r19.css(this.isHorizontal() ? 'width' : 'height', "".concat(this.pagination.bulletSize * (t.dynamicMainBullets + 4), "px")), t.dynamicMainBullets > 1 && void 0 !== this.previousIndex && (this.pagination.dynamicBulletIndex += _i19 - this.previousIndex, this.pagination.dynamicBulletIndex > t.dynamicMainBullets - 1 ? this.pagination.dynamicBulletIndex = t.dynamicMainBullets - 1 : this.pagination.dynamicBulletIndex < 0 && (this.pagination.dynamicBulletIndex = 0)), _o13 = _i19 - this.pagination.dynamicBulletIndex, _d12 = ((_l13 = _o13 + (Math.min(_h13.length, t.dynamicMainBullets) - 1)) + _o13) / 2), _h13.removeClass("".concat(t.bulletActiveClass, " ").concat(t.bulletActiveClass, "-next ").concat(t.bulletActiveClass, "-next-next ").concat(t.bulletActiveClass, "-prev ").concat(t.bulletActiveClass, "-prev-prev ").concat(t.bulletActiveClass, "-main")), _r19.length > 1) _h13.each(function (e, a) {
            var r = s(a);
            var n = r.index();
            n === _i19 && r.addClass(t.bulletActiveClass), t.dynamicBullets && (n >= _o13 && n <= _l13 && r.addClass("".concat(t.bulletActiveClass, "-main")), n === _o13 && r.prev().addClass("".concat(t.bulletActiveClass, "-prev")).prev().addClass("".concat(t.bulletActiveClass, "-prev-prev")), n === _l13 && r.next().addClass("".concat(t.bulletActiveClass, "-next")).next().addClass("".concat(t.bulletActiveClass, "-next-next")));
          });else {
            var _p10 = _h13.eq(_i19);
            var _c11 = _p10.index();
            if (_p10.addClass(t.bulletActiveClass), t.dynamicBullets) {
              for (var u = _h13.eq(_o13), v = _h13.eq(_l13), f = _o13; f <= _l13; f += 1) _h13.eq(f).addClass("".concat(t.bulletActiveClass, "-main"));
              if (this.params.loop) {
                if (_c11 >= _h13.length - t.dynamicMainBullets) {
                  for (var _m5 = t.dynamicMainBullets; _m5 >= 0; _m5 -= 1) _h13.eq(_h13.length - _m5).addClass("".concat(t.bulletActiveClass, "-main"));
                  _h13.eq(_h13.length - t.dynamicMainBullets - 1).addClass("".concat(t.bulletActiveClass, "-prev"));
                } else u.prev().addClass("".concat(t.bulletActiveClass, "-prev")).prev().addClass("".concat(t.bulletActiveClass, "-prev-prev")), v.next().addClass("".concat(t.bulletActiveClass, "-next")).next().addClass("".concat(t.bulletActiveClass, "-next-next"));
              } else u.prev().addClass("".concat(t.bulletActiveClass, "-prev")).prev().addClass("".concat(t.bulletActiveClass, "-prev-prev")), v.next().addClass("".concat(t.bulletActiveClass, "-next")).next().addClass("".concat(t.bulletActiveClass, "-next-next"));
            }
          }
          if (t.dynamicBullets) {
            var _g4 = Math.min(_h13.length, t.dynamicMainBullets + 4);
            var _b4 = (this.pagination.bulletSize * _g4 - this.pagination.bulletSize) / 2 - _d12 * this.pagination.bulletSize;
            var _w4 = e ? 'right' : 'left';
            _h13.css(this.isHorizontal() ? _w4 : 'top', "".concat(_b4, "px"));
          }
        }
        if (t.type === 'fraction' && (_r19.find(".".concat(t.currentClass)).text(t.formatFractionCurrent(_i19 + 1)), _r19.find(".".concat(t.totalClass)).text(t.formatFractionTotal(_n13))), t.type === 'progressbar') {
          var _y3;
          _y3 = t.progressbarOpposite ? this.isHorizontal() ? 'vertical' : 'horizontal' : this.isHorizontal() ? 'horizontal' : 'vertical';
          var _x3 = (_i19 + 1) / _n13;
          var _T3 = 1;
          var _E3 = 1;
          _y3 === 'horizontal' ? _T3 = _x3 : _E3 = _x3, _r19.find(".".concat(t.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(".concat(_T3, ") scaleY(").concat(_E3, ")")).transition(this.params.speed);
        }
        t.type === 'custom' && t.renderCustom ? (_r19.html(t.renderCustom(this, _i19 + 1, _n13)), this.emit('paginationRender', this, _r19[0])) : this.emit('paginationUpdate', this, _r19[0]), _r19[this.params.watchOverflow && this.isLocked ? 'addClass' : 'removeClass'](t.lockClass);
      }
    },
    render: function render() {
      var e = this.params.pagination;
      if (e.el && this.pagination.el && this.pagination.$el && this.pagination.$el.length !== 0) {
        var _t23 = this.virtual && this.params.virtual.enabled ? this.virtual.slides.length : this.slides.length;
        var _i20 = this.pagination.$el;
        var _s13 = '';
        if (e.type === 'bullets') {
          for (var _a14 = this.params.loop ? Math.ceil((_t23 - 2 * this.loopedSlides) / this.params.slidesPerGroup) : this.snapGrid.length, _r20 = 0; _r20 < _a14; _r20 += 1) e.renderBullet ? _s13 += e.renderBullet.call(this, _r20, e.bulletClass) : _s13 += "<".concat(e.bulletElement, " class=\"").concat(e.bulletClass, "\"></").concat(e.bulletElement, ">");
          _i20.html(_s13), this.pagination.bullets = _i20.find(".".concat(e.bulletClass));
        }
        e.type === 'fraction' && (_s13 = e.renderFraction ? e.renderFraction.call(this, e.currentClass, e.totalClass) : "<span class=\"".concat(e.currentClass, "\"></span> / <span class=\"").concat(e.totalClass, "\"></span>"), _i20.html(_s13)), e.type === 'progressbar' && (_s13 = e.renderProgressbar ? e.renderProgressbar.call(this, e.progressbarFillClass) : "<span class=\"".concat(e.progressbarFillClass, "\"></span>"), _i20.html(_s13)), e.type !== 'custom' && this.emit('paginationRender', this.pagination.$el[0]);
      }
    },
    init: function init() {
      var e = this;
      var t = e.params.pagination;
      if (t.el) {
        var _i21 = s(t.el);
        _i21.length !== 0 && (e.params.uniqueNavElements && typeof t.el === 'string' && _i21.length > 1 && e.$el.find(t.el).length === 1 && (_i21 = e.$el.find(t.el)), t.type === 'bullets' && t.clickable && _i21.addClass(t.clickableClass), _i21.addClass(t.modifierClass + t.type), t.type === 'bullets' && t.dynamicBullets && (_i21.addClass("".concat(t.modifierClass).concat(t.type, "-dynamic")), e.pagination.dynamicBulletIndex = 0, t.dynamicMainBullets < 1 && (t.dynamicMainBullets = 1)), t.type === 'progressbar' && t.progressbarOpposite && _i21.addClass(t.progressbarOppositeClass), t.clickable && _i21.on('click', ".".concat(t.bulletClass), function (t) {
          t.preventDefault();
          var i = s(this).index() * e.params.slidesPerGroup;
          e.params.loop && (i += e.loopedSlides), e.slideTo(i);
        }), n.extend(e.pagination, {
          $el: _i21,
          el: _i21[0]
        }));
      }
    },
    destroy: function destroy() {
      var e = this.params.pagination;
      if (e.el && this.pagination.el && this.pagination.$el && this.pagination.$el.length !== 0) {
        var _t24 = this.pagination.$el;
        _t24.removeClass(e.hiddenClass), _t24.removeClass(e.modifierClass + e.type), this.pagination.bullets && this.pagination.bullets.removeClass(e.bulletActiveClass), e.clickable && _t24.off('click', ".".concat(e.bulletClass));
      }
    }
  };
  var re = {
    setTranslate: function setTranslate() {
      if (this.params.scrollbar.el && this.scrollbar.el) {
        var _e5 = this.scrollbar;
        var _t25 = this.rtlTranslate;
        var _i22 = this.progress;
        var _s14 = _e5.dragSize;
        var _a15 = _e5.trackSize;
        var _r21 = _e5.$dragEl;
        var _n14 = _e5.$el;
        var _o14 = this.params.scrollbar;
        var _l14 = _s14;
        var _d13 = (_a15 - _s14) * _i22;
        _t25 ? (_d13 = -_d13) > 0 ? (_l14 = _s14 - _d13, _d13 = 0) : -_d13 + _s14 > _a15 && (_l14 = _a15 + _d13) : _d13 < 0 ? (_l14 = _s14 + _d13, _d13 = 0) : _d13 + _s14 > _a15 && (_l14 = _a15 - _d13), this.isHorizontal() ? (_r21.transform("translate3d(".concat(_d13, "px, 0, 0)")), _r21[0].style.width = "".concat(_l14, "px")) : (_r21.transform("translate3d(0px, ".concat(_d13, "px, 0)")), _r21[0].style.height = "".concat(_l14, "px")), _o14.hide && (clearTimeout(this.scrollbar.timeout), _n14[0].style.opacity = 1, this.scrollbar.timeout = setTimeout(function () {
          _n14[0].style.opacity = 0, _n14.transition(400);
        }, 1e3));
      }
    },
    setTransition: function setTransition(e) {
      this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e);
    },
    updateSize: function updateSize() {
      if (this.params.scrollbar.el && this.scrollbar.el) {
        var _e6 = this.scrollbar;
        var _t26 = _e6.$dragEl;
        var _i23 = _e6.$el;
        _t26[0].style.width = '', _t26[0].style.height = '';
        var _s15;
        var _a16 = this.isHorizontal() ? _i23[0].offsetWidth : _i23[0].offsetHeight;
        var _r22 = this.size / this.virtualSize;
        var _o15 = _r22 * (_a16 / this.size);
        _s15 = this.params.scrollbar.dragSize === 'auto' ? _a16 * _r22 : parseInt(this.params.scrollbar.dragSize, 10), this.isHorizontal() ? _t26[0].style.width = "".concat(_s15, "px") : _t26[0].style.height = "".concat(_s15, "px"), _i23[0].style.display = _r22 >= 1 ? 'none' : '', this.params.scrollbar.hide && (_i23[0].style.opacity = 0), n.extend(_e6, {
          trackSize: _a16,
          divider: _r22,
          moveDivider: _o15,
          dragSize: _s15
        }), _e6.$el[this.params.watchOverflow && this.isLocked ? 'addClass' : 'removeClass'](this.params.scrollbar.lockClass);
      }
    },
    getPointerPosition: function getPointerPosition(e) {
      return this.isHorizontal() ? e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX : e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    },
    setDragPosition: function setDragPosition(e) {
      var t;
      var i = this.scrollbar;
      var s = this.rtlTranslate;
      var a = i.$el;
      var r = i.dragSize;
      var n = i.trackSize;
      var o = i.dragStartPos;
      t = (i.getPointerPosition(e) - a.offset()[this.isHorizontal() ? 'left' : 'top'] - (o !== null ? o : r / 2)) / (n - r), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t);
      var l = this.minTranslate() + (this.maxTranslate() - this.minTranslate()) * t;
      this.updateProgress(l), this.setTranslate(l), this.updateActiveIndex(), this.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var t = this.params.scrollbar;
      var i = this.scrollbar;
      var s = this.$wrapperEl;
      var a = i.$el;
      var r = i.$dragEl;
      this.scrollbar.isTouched = !0, this.scrollbar.dragStartPos = e.target === r[0] || e.target === r ? i.getPointerPosition(e) - e.target.getBoundingClientRect()[this.isHorizontal() ? 'left' : 'top'] : null, e.preventDefault(), e.stopPropagation(), s.transition(100), r.transition(100), i.setDragPosition(e), clearTimeout(this.scrollbar.dragTimeout), a.transition(0), t.hide && a.css('opacity', 1), this.params.cssMode && this.$wrapperEl.css('scroll-snap-type', 'none'), this.emit('scrollbarDragStart', e);
    },
    onDragMove: function onDragMove(e) {
      var t = this.scrollbar;
      var i = this.$wrapperEl;
      var s = t.$el;
      var a = t.$dragEl;
      this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, t.setDragPosition(e), i.transition(0), s.transition(0), a.transition(0), this.emit('scrollbarDragMove', e));
    },
    onDragEnd: function onDragEnd(e) {
      var t = this.params.scrollbar;
      var i = this.scrollbar;
      var s = this.$wrapperEl;
      var a = i.$el;
      this.scrollbar.isTouched && (this.scrollbar.isTouched = !1, this.params.cssMode && (this.$wrapperEl.css('scroll-snap-type', ''), s.transition('')), t.hide && (clearTimeout(this.scrollbar.dragTimeout), this.scrollbar.dragTimeout = n.nextTick(function () {
        a.css('opacity', 0), a.transition(400);
      }, 1e3)), this.emit('scrollbarDragEnd', e), t.snapOnRelease && this.slideToClosest());
    },
    enableDraggable: function enableDraggable() {
      if (this.params.scrollbar.el) {
        var _t27 = this.scrollbar;
        var _i24 = this.touchEventsTouch;
        var _s16 = this.touchEventsDesktop;
        var _a17 = this.params;
        var _r23 = _t27.$el[0];
        var _n15 = !(!o.passiveListener || !_a17.passiveListeners) && {
          passive: !1,
          capture: !1
        };
        var _l15 = !(!o.passiveListener || !_a17.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        o.touch ? (_r23.addEventListener(_i24.start, this.scrollbar.onDragStart, _n15), _r23.addEventListener(_i24.move, this.scrollbar.onDragMove, _n15), _r23.addEventListener(_i24.end, this.scrollbar.onDragEnd, _l15)) : (_r23.addEventListener(_s16.start, this.scrollbar.onDragStart, _n15), e.addEventListener(_s16.move, this.scrollbar.onDragMove, _n15), e.addEventListener(_s16.end, this.scrollbar.onDragEnd, _l15));
      }
    },
    disableDraggable: function disableDraggable() {
      if (this.params.scrollbar.el) {
        var _t28 = this.scrollbar;
        var _i25 = this.touchEventsTouch;
        var _s17 = this.touchEventsDesktop;
        var _a18 = this.params;
        var _r24 = _t28.$el[0];
        var _n16 = !(!o.passiveListener || !_a18.passiveListeners) && {
          passive: !1,
          capture: !1
        };
        var _l16 = !(!o.passiveListener || !_a18.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        o.touch ? (_r24.removeEventListener(_i25.start, this.scrollbar.onDragStart, _n16), _r24.removeEventListener(_i25.move, this.scrollbar.onDragMove, _n16), _r24.removeEventListener(_i25.end, this.scrollbar.onDragEnd, _l16)) : (_r24.removeEventListener(_s17.start, this.scrollbar.onDragStart, _n16), e.removeEventListener(_s17.move, this.scrollbar.onDragMove, _n16), e.removeEventListener(_s17.end, this.scrollbar.onDragEnd, _l16));
      }
    },
    init: function init() {
      if (this.params.scrollbar.el) {
        var _e7 = this.scrollbar;
        var _t29 = this.$el;
        var _i26 = this.params.scrollbar;
        var _a19 = s(_i26.el);
        this.params.uniqueNavElements && typeof _i26.el === 'string' && _a19.length > 1 && _t29.find(_i26.el).length === 1 && (_a19 = _t29.find(_i26.el));
        var _r25 = _a19.find(".".concat(this.params.scrollbar.dragClass));
        _r25.length === 0 && (_r25 = s("<div class=\"".concat(this.params.scrollbar.dragClass, "\"></div>")), _a19.append(_r25)), n.extend(_e7, {
          $el: _a19,
          el: _a19[0],
          $dragEl: _r25,
          dragEl: _r25[0]
        }), _i26.draggable && _e7.enableDraggable();
      }
    },
    destroy: function destroy() {
      this.scrollbar.disableDraggable();
    }
  };
  var ne = {
    setTransform: function setTransform(e, t) {
      var i = this.rtl;
      var a = s(e);
      var r = i ? -1 : 1;
      var n = a.attr('data-swiper-parallax') || '0';
      var o = a.attr('data-swiper-parallax-x');
      var l = a.attr('data-swiper-parallax-y');
      var d = a.attr('data-swiper-parallax-scale');
      var h = a.attr('data-swiper-parallax-opacity');
      if (o || l ? (o = o || '0', l = l || '0') : this.isHorizontal() ? (o = n, l = '0') : (l = n, o = '0'), o = o.indexOf('%') >= 0 ? "".concat(parseInt(o, 10) * t * r, "%") : "".concat(o * t * r, "px"), l = l.indexOf('%') >= 0 ? "".concat(parseInt(l, 10) * t, "%") : "".concat(l * t, "px"), h != null) {
        var _p11 = h - (h - 1) * (1 - Math.abs(t));
        a[0].style.opacity = _p11;
      }
      if (d == null) a.transform("translate3d(".concat(o, ", ").concat(l, ", 0px)"));else {
        var _c12 = d - (d - 1) * (1 - Math.abs(t));
        a.transform("translate3d(".concat(o, ", ").concat(l, ", 0px) scale(").concat(_c12, ")"));
      }
    },
    setTranslate: function setTranslate() {
      var e = this;
      var t = e.$el;
      var i = e.slides;
      var a = e.progress;
      var r = e.snapGrid;
      t.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (t, i) {
        e.parallax.setTransform(i, a);
      }), i.each(function (t, i) {
        var n = i.progress;
        e.params.slidesPerGroup > 1 && e.params.slidesPerView !== 'auto' && (n += Math.ceil(t / 2) - a * (r.length - 1)), n = Math.min(Math.max(n, -1), 1), s(i).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (t, i) {
          e.parallax.setTransform(i, n);
        });
      });
    },
    setTransition: function setTransition(e) {
      void 0 === e && (e = this.params.speed);
      this.$el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (t, i) {
        var a = s(i);
        var r = parseInt(a.attr('data-swiper-parallax-duration'), 10) || e;
        e === 0 && (r = 0), a.transition(r);
      });
    }
  };
  var oe = {
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) return 1;
      var t = e.targetTouches[0].pageX;
      var i = e.targetTouches[0].pageY;
      var s = e.targetTouches[1].pageX;
      var a = e.targetTouches[1].pageY;
      return Math.sqrt(Math.pow(s - t, 2) + Math.pow(a - i, 2));
    },
    onGestureStart: function onGestureStart(e) {
      var t = this.params.zoom;
      var i = this.zoom;
      var a = i.gesture;
      if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !o.gestures) {
        if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
        i.fakeGestureTouched = !0, a.scaleStart = oe.getDistanceBetweenTouches(e);
      }
      a.$slideEl && a.$slideEl.length || (a.$slideEl = s(e.target).closest(".".concat(this.params.slideClass)), a.$slideEl.length === 0 && (a.$slideEl = this.slides.eq(this.activeIndex)), a.$imageEl = a.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target'), a.$imageWrapEl = a.$imageEl.parent(".".concat(t.containerClass)), a.maxRatio = a.$imageWrapEl.attr('data-swiper-zoom') || t.maxRatio, a.$imageWrapEl.length !== 0) ? (a.$imageEl.transition(0), this.zoom.isScaling = !0) : a.$imageEl = void 0;
    },
    onGestureChange: function onGestureChange(e) {
      var t = this.params.zoom;
      var i = this.zoom;
      var s = i.gesture;
      if (!o.gestures) {
        if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
        i.fakeGestureMoved = !0, s.scaleMove = oe.getDistanceBetweenTouches(e);
      }
      s.$imageEl && s.$imageEl.length !== 0 && (o.gestures ? i.scale = e.scale * i.currentScale : i.scale = s.scaleMove / s.scaleStart * i.currentScale, i.scale > s.maxRatio && (i.scale = s.maxRatio - 1 + Math.pow(i.scale - s.maxRatio + 1, 0.5)), i.scale < t.minRatio && (i.scale = t.minRatio + 1 - Math.pow(t.minRatio - i.scale + 1, 0.5)), s.$imageEl.transform("translate3d(0,0,0) scale(".concat(i.scale, ")")));
    },
    onGestureEnd: function onGestureEnd(e) {
      var t = this.params.zoom;
      var i = this.zoom;
      var s = i.gesture;
      if (!o.gestures) {
        if (!i.fakeGestureTouched || !i.fakeGestureMoved) return;
        if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !I.android) return;
        i.fakeGestureTouched = !1, i.fakeGestureMoved = !1;
      }
      s.$imageEl && s.$imageEl.length !== 0 && (i.scale = Math.max(Math.min(i.scale, s.maxRatio), t.minRatio), s.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(".concat(i.scale, ")")), i.currentScale = i.scale, i.isScaling = !1, i.scale === 1 && (s.$slideEl = void 0));
    },
    onTouchStart: function onTouchStart(e) {
      var t = this.zoom;
      var i = t.gesture;
      var s = t.image;
      i.$imageEl && i.$imageEl.length !== 0 && (s.isTouched || (I.android && e.preventDefault(), s.isTouched = !0, s.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX, s.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY));
    },
    onTouchMove: function onTouchMove(e) {
      var t = this.zoom;
      var i = t.gesture;
      var s = t.image;
      var a = t.velocity;
      if (i.$imageEl && i.$imageEl.length !== 0 && (this.allowClick = !1, s.isTouched && i.$slideEl)) {
        s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = n.getTranslate(i.$imageWrapEl[0], 'x') || 0, s.startY = n.getTranslate(i.$imageWrapEl[0], 'y') || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), this.rtl && (s.startX = -s.startX, s.startY = -s.startY));
        var _r26 = s.width * t.scale;
        var _o16 = s.height * t.scale;
        if (!(_r26 < i.slideWidth && _o16 < i.slideHeight)) {
          if (s.minX = Math.min(i.slideWidth / 2 - _r26 / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - _o16 / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !t.isScaling) {
            if (this.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void (s.isTouched = !1);
            if (!this.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void (s.isTouched = !1);
          }
          e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, 0.8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, 0.8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, 0.8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, 0.8)), a.prevPositionX || (a.prevPositionX = s.touchesCurrent.x), a.prevPositionY || (a.prevPositionY = s.touchesCurrent.y), a.prevTime || (a.prevTime = Date.now()), a.x = (s.touchesCurrent.x - a.prevPositionX) / (Date.now() - a.prevTime) / 2, a.y = (s.touchesCurrent.y - a.prevPositionY) / (Date.now() - a.prevTime) / 2, Math.abs(s.touchesCurrent.x - a.prevPositionX) < 2 && (a.x = 0), Math.abs(s.touchesCurrent.y - a.prevPositionY) < 2 && (a.y = 0), a.prevPositionX = s.touchesCurrent.x, a.prevPositionY = s.touchesCurrent.y, a.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(".concat(s.currentX, "px, ").concat(s.currentY, "px,0)"));
        }
      }
    },
    onTouchEnd: function onTouchEnd() {
      var e = this.zoom;
      var t = e.gesture;
      var i = e.image;
      var s = e.velocity;
      if (t.$imageEl && t.$imageEl.length !== 0) {
        if (!i.isTouched || !i.isMoved) return i.isTouched = !1, void (i.isMoved = !1);
        i.isTouched = !1, i.isMoved = !1;
        var _a20 = 300;
        var _r27 = 300;
        var _n17 = s.x * _a20;
        var _o17 = i.currentX + _n17;
        var _l17 = s.y * _r27;
        var _d14 = i.currentY + _l17;
        s.x !== 0 && (_a20 = Math.abs((_o17 - i.currentX) / s.x)), s.y !== 0 && (_r27 = Math.abs((_d14 - i.currentY) / s.y));
        var _h14 = Math.max(_a20, _r27);
        i.currentX = _o17, i.currentY = _d14;
        var _p12 = i.width * e.scale;
        var _c13 = i.height * e.scale;
        i.minX = Math.min(t.slideWidth / 2 - _p12 / 2, 0), i.maxX = -i.minX, i.minY = Math.min(t.slideHeight / 2 - _c13 / 2, 0), i.maxY = -i.minY, i.currentX = Math.max(Math.min(i.currentX, i.maxX), i.minX), i.currentY = Math.max(Math.min(i.currentY, i.maxY), i.minY), t.$imageWrapEl.transition(_h14).transform("translate3d(".concat(i.currentX, "px, ").concat(i.currentY, "px,0)"));
      }
    },
    onTransitionEnd: function onTransitionEnd() {
      var e = this.zoom;
      var t = e.gesture;
      t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl.transform('translate3d(0,0,0) scale(1)'), t.$imageWrapEl.transform('translate3d(0,0,0)'), e.scale = 1, e.currentScale = 1, t.$slideEl = void 0, t.$imageEl = void 0, t.$imageWrapEl = void 0);
    },
    toggle: function toggle(e) {
      var t = this.zoom;
      t.scale && t.scale !== 1 ? t.out() : t["in"](e);
    },
    "in": function _in(e) {
      var t;
      var i;
      var s;
      var a;
      var r;
      var n;
      var o;
      var l;
      var d;
      var h;
      var p;
      var c;
      var u;
      var v;
      var f;
      var m;
      var g = this.zoom;
      var b = this.params.zoom;
      var w = g.gesture;
      var y = g.image;
      (w.$slideEl || (w.$slideEl = this.slides.eq(this.activeIndex), w.$imageEl = w.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target'), w.$imageWrapEl = w.$imageEl.parent(".".concat(b.containerClass))), w.$imageEl && w.$imageEl.length !== 0) && (w.$slideEl.addClass("".concat(b.zoomedSlideClass)), void 0 === y.touchesStart.x && e ? (t = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX, i = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY) : (t = y.touchesStart.x, i = y.touchesStart.y), g.scale = w.$imageWrapEl.attr('data-swiper-zoom') || b.maxRatio, g.currentScale = w.$imageWrapEl.attr('data-swiper-zoom') || b.maxRatio, e ? (f = w.$slideEl[0].offsetWidth, m = w.$slideEl[0].offsetHeight, s = w.$slideEl.offset().left + f / 2 - t, a = w.$slideEl.offset().top + m / 2 - i, o = w.$imageEl[0].offsetWidth, l = w.$imageEl[0].offsetHeight, d = o * g.scale, h = l * g.scale, u = -(p = Math.min(f / 2 - d / 2, 0)), v = -(c = Math.min(m / 2 - h / 2, 0)), (r = s * g.scale) < p && (r = p), r > u && (r = u), (n = a * g.scale) < c && (n = c), n > v && (n = v)) : (r = 0, n = 0), w.$imageWrapEl.transition(300).transform("translate3d(".concat(r, "px, ").concat(n, "px,0)")), w.$imageEl.transition(300).transform("translate3d(0,0,0) scale(".concat(g.scale, ")")));
    },
    out: function out() {
      var e = this.zoom;
      var t = this.params.zoom;
      var i = e.gesture;
      i.$slideEl || (i.$slideEl = this.slides.eq(this.activeIndex), i.$imageEl = i.$slideEl.find('img, svg, canvas, picture, .swiper-zoom-target'), i.$imageWrapEl = i.$imageEl.parent(".".concat(t.containerClass))), i.$imageEl && i.$imageEl.length !== 0 && (e.scale = 1, e.currentScale = 1, i.$imageWrapEl.transition(300).transform('translate3d(0,0,0)'), i.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)'), i.$slideEl.removeClass("".concat(t.zoomedSlideClass)), i.$slideEl = void 0);
    },
    enable: function enable() {
      var e = this.zoom;
      if (!e.enabled) {
        e.enabled = !0;
        var _t30 = !(this.touchEvents.start !== 'touchstart' || !o.passiveListener || !this.params.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        var _i27 = !o.passiveListener || {
          passive: !1,
          capture: !0
        };
        var _s18 = ".".concat(this.params.slideClass);
        o.gestures ? (this.$wrapperEl.on('gesturestart', _s18, e.onGestureStart, _t30), this.$wrapperEl.on('gesturechange', _s18, e.onGestureChange, _t30), this.$wrapperEl.on('gestureend', _s18, e.onGestureEnd, _t30)) : this.touchEvents.start === 'touchstart' && (this.$wrapperEl.on(this.touchEvents.start, _s18, e.onGestureStart, _t30), this.$wrapperEl.on(this.touchEvents.move, _s18, e.onGestureChange, _i27), this.$wrapperEl.on(this.touchEvents.end, _s18, e.onGestureEnd, _t30), this.touchEvents.cancel && this.$wrapperEl.on(this.touchEvents.cancel, _s18, e.onGestureEnd, _t30)), this.$wrapperEl.on(this.touchEvents.move, ".".concat(this.params.zoom.containerClass), e.onTouchMove, _i27);
      }
    },
    disable: function disable() {
      var e = this.zoom;
      if (e.enabled) {
        this.zoom.enabled = !1;
        var _t31 = !(this.touchEvents.start !== 'touchstart' || !o.passiveListener || !this.params.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        var _i28 = !o.passiveListener || {
          passive: !1,
          capture: !0
        };
        var _s19 = ".".concat(this.params.slideClass);
        o.gestures ? (this.$wrapperEl.off('gesturestart', _s19, e.onGestureStart, _t31), this.$wrapperEl.off('gesturechange', _s19, e.onGestureChange, _t31), this.$wrapperEl.off('gestureend', _s19, e.onGestureEnd, _t31)) : this.touchEvents.start === 'touchstart' && (this.$wrapperEl.off(this.touchEvents.start, _s19, e.onGestureStart, _t31), this.$wrapperEl.off(this.touchEvents.move, _s19, e.onGestureChange, _i28), this.$wrapperEl.off(this.touchEvents.end, _s19, e.onGestureEnd, _t31), this.touchEvents.cancel && this.$wrapperEl.off(this.touchEvents.cancel, _s19, e.onGestureEnd, _t31)), this.$wrapperEl.off(this.touchEvents.move, ".".concat(this.params.zoom.containerClass), e.onTouchMove, _i28);
      }
    }
  };
  var le = {
    loadInSlide: function loadInSlide(e, t) {
      void 0 === t && (t = !0);
      var i = this;
      var a = i.params.lazy;
      if (void 0 !== e && i.slides.length !== 0) {
        var _r28 = i.virtual && i.params.virtual.enabled ? i.$wrapperEl.children(".".concat(i.params.slideClass, "[data-swiper-slide-index=\"").concat(e, "\"]")) : i.slides.eq(e);
        var _n18 = _r28.find(".".concat(a.elementClass, ":not(.").concat(a.loadedClass, "):not(.").concat(a.loadingClass, ")"));
        !_r28.hasClass(a.elementClass) || _r28.hasClass(a.loadedClass) || _r28.hasClass(a.loadingClass) || (_n18 = _n18.add(_r28[0])), _n18.length !== 0 && _n18.each(function (e, n) {
          var o = s(n);
          o.addClass(a.loadingClass);
          var l = o.attr('data-background');
          var d = o.attr('data-src');
          var h = o.attr('data-srcset');
          var p = o.attr('data-sizes');
          i.loadImage(o[0], d || l, h, p, !1, function () {
            if (i != null && i && (!i || i.params) && !i.destroyed) {
              if (l ? (o.css('background-image', "url(\"".concat(l, "\")")), o.removeAttr('data-background')) : (h && (o.attr('srcset', h), o.removeAttr('data-srcset')), p && (o.attr('sizes', p), o.removeAttr('data-sizes')), d && (o.attr('src', d), o.removeAttr('data-src'))), o.addClass(a.loadedClass).removeClass(a.loadingClass), _r28.find(".".concat(a.preloaderClass)).remove(), i.params.loop && t) {
                var _e8 = _r28.attr('data-swiper-slide-index');
                if (_r28.hasClass(i.params.slideDuplicateClass)) {
                  var _s20 = i.$wrapperEl.children("[data-swiper-slide-index=\"".concat(_e8, "\"]:not(.").concat(i.params.slideDuplicateClass, ")"));
                  i.lazy.loadInSlide(_s20.index(), !1);
                } else {
                  var _n19 = i.$wrapperEl.children(".".concat(i.params.slideDuplicateClass, "[data-swiper-slide-index=\"").concat(_e8, "\"]"));
                  i.lazy.loadInSlide(_n19.index(), !1);
                }
              }
              i.emit('lazyImageReady', _r28[0], o[0]), i.params.autoHeight && i.updateAutoHeight();
            }
          }), i.emit('lazyImageLoad', _r28[0], o[0]);
        });
      }
    },
    load: function load() {
      var e = this;
      var t = e.$wrapperEl;
      var i = e.params;
      var a = e.slides;
      var r = e.activeIndex;
      var n = e.virtual && i.virtual.enabled;
      var o = i.lazy;
      var l = i.slidesPerView;
      function d(e) {
        if (n) {
          if (t.children(".".concat(i.slideClass, "[data-swiper-slide-index=\"").concat(e, "\"]")).length) return !0;
        } else if (a[e]) return !0;
        return !1;
      }
      function h(e) {
        return n ? s(e).attr('data-swiper-slide-index') : s(e).index();
      }
      if (l === 'auto' && (l = 0), e.lazy.initialImageLoaded || (e.lazy.initialImageLoaded = !0), e.params.watchSlidesVisibility) t.children(".".concat(i.slideVisibleClass)).each(function (t, i) {
        var a = n ? s(i).attr('data-swiper-slide-index') : s(i).index();
        e.lazy.loadInSlide(a);
      });else if (l > 1) for (var _p13 = r; _p13 < r + l; _p13 += 1) d(_p13) && e.lazy.loadInSlide(_p13);else e.lazy.loadInSlide(r);
      if (o.loadPrevNext) if (l > 1 || o.loadPrevNextAmount && o.loadPrevNextAmount > 1) {
        for (var c = o.loadPrevNextAmount, u = l, v = Math.min(r + u + Math.max(c, u), a.length), f = Math.max(r - Math.max(u, c), 0), m = r + l; m < v; m += 1) d(m) && e.lazy.loadInSlide(m);
        for (var _g5 = f; _g5 < r; _g5 += 1) d(_g5) && e.lazy.loadInSlide(_g5);
      } else {
        var _b5 = t.children(".".concat(i.slideNextClass));
        _b5.length > 0 && e.lazy.loadInSlide(h(_b5));
        var _w5 = t.children(".".concat(i.slidePrevClass));
        _w5.length > 0 && e.lazy.loadInSlide(h(_w5));
      }
    }
  };
  var de = {
    LinearSpline: function LinearSpline(e, t) {
      var i;
      var s;
      var a;
      var r;
      var n;
      var o = function o(e, t) {
        for (s = -1, i = e.length; i - s > 1;) e[a = i + s >> 1] <= t ? s = a : i = a;
        return i;
      };
      return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function (e) {
        return e ? (n = o(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0;
      }, this;
    },
    getInterpolateFunction: function getInterpolateFunction(e) {
      this.controller.spline || (this.controller.spline = this.params.loop ? new de.LinearSpline(this.slidesGrid, e.slidesGrid) : new de.LinearSpline(this.snapGrid, e.snapGrid));
    },
    setTranslate: function setTranslate(e, t) {
      var i;
      var s;
      var a = this;
      var r = a.controller.control;
      function n(e) {
        var t = a.rtlTranslate ? -a.translate : a.translate;
        a.params.controller.by === 'slide' && (a.controller.getInterpolateFunction(e), s = -a.controller.spline.interpolate(-t)), s && a.params.controller.by !== 'container' || (i = (e.maxTranslate() - e.minTranslate()) / (a.maxTranslate() - a.minTranslate()), s = (t - a.minTranslate()) * i + e.minTranslate()), a.params.controller.inverse && (s = e.maxTranslate() - s), e.updateProgress(s), e.setTranslate(s, a), e.updateActiveIndex(), e.updateSlidesClasses();
      }
      if (Array.isArray(r)) for (var _o18 = 0; _o18 < r.length; _o18 += 1) r[_o18] !== t && r[_o18] instanceof W && n(r[_o18]);else r instanceof W && t !== r && n(r);
    },
    setTransition: function setTransition(e, t) {
      var i;
      var s = this;
      var a = s.controller.control;
      function r(t) {
        t.setTransition(e, s), e !== 0 && (t.transitionStart(), t.params.autoHeight && n.nextTick(function () {
          t.updateAutoHeight();
        }), t.$wrapperEl.transitionEnd(function () {
          a && (t.params.loop && s.params.controller.by === 'slide' && t.loopFix(), t.transitionEnd());
        }));
      }
      if (Array.isArray(a)) for (i = 0; i < a.length; i += 1) a[i] !== t && a[i] instanceof W && r(a[i]);else a instanceof W && t !== a && r(a);
    }
  };
  var he = {
    makeElFocusable: function makeElFocusable(e) {
      return e.attr('tabIndex', '0'), e;
    },
    addElRole: function addElRole(e, t) {
      return e.attr('role', t), e;
    },
    addElLabel: function addElLabel(e, t) {
      return e.attr('aria-label', t), e;
    },
    disableEl: function disableEl(e) {
      return e.attr('aria-disabled', !0), e;
    },
    enableEl: function enableEl(e) {
      return e.attr('aria-disabled', !1), e;
    },
    onEnterKey: function onEnterKey(e) {
      var t = this.params.a11y;
      if (e.keyCode === 13) {
        var _i29 = s(e.target);
        this.navigation && this.navigation.$nextEl && _i29.is(this.navigation.$nextEl) && (this.isEnd && !this.params.loop || this.slideNext(), this.isEnd ? this.a11y.notify(t.lastSlideMessage) : this.a11y.notify(t.nextSlideMessage)), this.navigation && this.navigation.$prevEl && _i29.is(this.navigation.$prevEl) && (this.isBeginning && !this.params.loop || this.slidePrev(), this.isBeginning ? this.a11y.notify(t.firstSlideMessage) : this.a11y.notify(t.prevSlideMessage)), this.pagination && _i29.is(".".concat(this.params.pagination.bulletClass)) && _i29[0].click();
      }
    },
    notify: function notify(e) {
      var t = this.a11y.liveRegion;
      t.length !== 0 && (t.html(''), t.html(e));
    },
    updateNavigation: function updateNavigation() {
      if (!this.params.loop && this.navigation) {
        var _e9 = this.navigation;
        var _t32 = _e9.$nextEl;
        var _i30 = _e9.$prevEl;
        _i30 && _i30.length > 0 && (this.isBeginning ? this.a11y.disableEl(_i30) : this.a11y.enableEl(_i30)), _t32 && _t32.length > 0 && (this.isEnd ? this.a11y.disableEl(_t32) : this.a11y.enableEl(_t32));
      }
    },
    updatePagination: function updatePagination() {
      var e = this;
      var t = e.params.a11y;
      e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.bullets.each(function (i, a) {
        var r = s(a);
        e.a11y.makeElFocusable(r), e.a11y.addElRole(r, 'button'), e.a11y.addElLabel(r, t.paginationBulletMessage.replace(/{{index}}/, r.index() + 1));
      });
    },
    init: function init() {
      this.$el.append(this.a11y.liveRegion);
      var e;
      var t;
      var i = this.params.a11y;
      this.navigation && this.navigation.$nextEl && (e = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (t = this.navigation.$prevEl), e && (this.a11y.makeElFocusable(e), this.a11y.addElRole(e, 'button'), this.a11y.addElLabel(e, i.nextSlideMessage), e.on('keydown', this.a11y.onEnterKey)), t && (this.a11y.makeElFocusable(t), this.a11y.addElRole(t, 'button'), this.a11y.addElLabel(t, i.prevSlideMessage), t.on('keydown', this.a11y.onEnterKey)), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.on('keydown', ".".concat(this.params.pagination.bulletClass), this.a11y.onEnterKey);
    },
    destroy: function destroy() {
      var e;
      var t;
      this.a11y.liveRegion && this.a11y.liveRegion.length > 0 && this.a11y.liveRegion.remove(), this.navigation && this.navigation.$nextEl && (e = this.navigation.$nextEl), this.navigation && this.navigation.$prevEl && (t = this.navigation.$prevEl), e && e.off('keydown', this.a11y.onEnterKey), t && t.off('keydown', this.a11y.onEnterKey), this.pagination && this.params.pagination.clickable && this.pagination.bullets && this.pagination.bullets.length && this.pagination.$el.off('keydown', ".".concat(this.params.pagination.bulletClass), this.a11y.onEnterKey);
    }
  };
  var pe = {
    init: function init() {
      if (this.params.history) {
        if (!t.history || !t.history.pushState) return this.params.history.enabled = !1, void (this.params.hashNavigation.enabled = !0);
        var _e10 = this.history;
        _e10.initialized = !0, _e10.paths = pe.getPathValues(), (_e10.paths.key || _e10.paths.value) && (_e10.scrollToSlide(0, _e10.paths.value, this.params.runCallbacksOnInit), this.params.history.replaceState || t.addEventListener('popstate', this.history.setHistoryPopState));
      }
    },
    destroy: function destroy() {
      this.params.history.replaceState || t.removeEventListener('popstate', this.history.setHistoryPopState);
    },
    setHistoryPopState: function setHistoryPopState() {
      this.history.paths = pe.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1);
    },
    getPathValues: function getPathValues() {
      var e = t.location.pathname.slice(1).split('/').filter(function (e) {
        return e !== '';
      });
      var i = e.length;
      return {
        key: e[i - 2],
        value: e[i - 1]
      };
    },
    setHistory: function setHistory(e, i) {
      if (this.history.initialized && this.params.history.enabled) {
        var _s21 = this.slides.eq(i);
        var _a21 = pe.slugify(_s21.attr('data-history'));
        t.location.pathname.includes(e) || (_a21 = "".concat(e, "/").concat(_a21));
        var _r29 = t.history.state;
        _r29 && _r29.value === _a21 || (this.params.history.replaceState ? t.history.replaceState({
          value: _a21
        }, null, _a21) : t.history.pushState({
          value: _a21
        }, null, _a21));
      }
    },
    slugify: function slugify(e) {
      return e.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    },
    scrollToSlide: function scrollToSlide(e, t, i) {
      if (t) for (var _s22 = 0, _a22 = this.slides.length; _s22 < _a22; _s22 += 1) {
        var _r30 = this.slides.eq(_s22);
        if (pe.slugify(_r30.attr('data-history')) === t && !_r30.hasClass(this.params.slideDuplicateClass)) {
          var _n20 = _r30.index();
          this.slideTo(_n20, e, i);
        }
      } else this.slideTo(0, e, i);
    }
  };
  var ce = {
    onHashCange: function onHashCange() {
      var t = e.location.hash.replace('#', '');
      if (t !== this.slides.eq(this.activeIndex).attr('data-hash')) {
        var _i31 = this.$wrapperEl.children(".".concat(this.params.slideClass, "[data-hash=\"").concat(t, "\"]")).index();
        if (void 0 === _i31) return;
        this.slideTo(_i31);
      }
    },
    setHash: function setHash() {
      if (this.hashNavigation.initialized && this.params.hashNavigation.enabled) if (this.params.hashNavigation.replaceState && t.history && t.history.replaceState) t.history.replaceState(null, null, "#".concat(this.slides.eq(this.activeIndex).attr('data-hash')) || '');else {
        var _i32 = this.slides.eq(this.activeIndex);
        var _s23 = _i32.attr('data-hash') || _i32.attr('data-history');
        e.location.hash = _s23 || '';
      }
    },
    init: function init() {
      if (!(!this.params.hashNavigation.enabled || this.params.history && this.params.history.enabled)) {
        this.hashNavigation.initialized = !0;
        var _i33 = e.location.hash.replace('#', '');
        if (_i33) for (var _a23 = 0, _r31 = this.slides.length; _a23 < _r31; _a23 += 1) {
          var _n21 = this.slides.eq(_a23);
          if ((_n21.attr('data-hash') || _n21.attr('data-history')) === _i33 && !_n21.hasClass(this.params.slideDuplicateClass)) {
            var _o19 = _n21.index();
            this.slideTo(_o19, 0, this.params.runCallbacksOnInit, !0);
          }
        }
        this.params.hashNavigation.watchState && s(t).on('hashchange', this.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      this.params.hashNavigation.watchState && s(t).off('hashchange', this.hashNavigation.onHashCange);
    }
  };
  var ue = {
    run: function run() {
      var e = this;
      var t = e.slides.eq(e.activeIndex);
      var i = e.params.autoplay.delay;
      t.attr('data-swiper-autoplay') && (i = t.attr('data-swiper-autoplay') || e.params.autoplay.delay), clearTimeout(e.autoplay.timeout), e.autoplay.timeout = n.nextTick(function () {
        e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit('autoplay')) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit('autoplay')) : (e.slidePrev(e.params.speed, !0, !0), e.emit('autoplay')) : e.params.loop ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit('autoplay')) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0), e.emit('autoplay')) : (e.slideNext(e.params.speed, !0, !0), e.emit('autoplay')), e.params.cssMode && e.autoplay.running && e.autoplay.run();
      }, i);
    },
    start: function start() {
      return void 0 === this.autoplay.timeout && !this.autoplay.running && (this.autoplay.running = !0, this.emit('autoplayStart'), this.autoplay.run(), !0);
    },
    stop: function stop() {
      return !!this.autoplay.running && void 0 !== this.autoplay.timeout && (this.autoplay.timeout && (clearTimeout(this.autoplay.timeout), this.autoplay.timeout = void 0), this.autoplay.running = !1, this.emit('autoplayStop'), !0);
    },
    pause: function pause(e) {
      this.autoplay.running && (this.autoplay.paused || (this.autoplay.timeout && clearTimeout(this.autoplay.timeout), this.autoplay.paused = !0, e !== 0 && this.params.autoplay.waitForTransition ? (this.$wrapperEl[0].addEventListener('transitionend', this.autoplay.onTransitionEnd), this.$wrapperEl[0].addEventListener('webkitTransitionEnd', this.autoplay.onTransitionEnd)) : (this.autoplay.paused = !1, this.autoplay.run())));
    }
  };
  var ve = {
    setTranslate: function setTranslate() {
      for (var _e11 = this.slides, _t33 = 0; _t33 < _e11.length; _t33 += 1) {
        var _i34 = this.slides.eq(_t33);
        var _s24 = -_i34[0].swiperSlideOffset;
        this.params.virtualTranslate || (_s24 -= this.translate);
        var _a24 = 0;
        this.isHorizontal() || (_a24 = _s24, _s24 = 0);
        var _r32 = this.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(_i34[0].progress), 0) : 1 + Math.min(Math.max(_i34[0].progress, -1), 0);
        _i34.css({
          opacity: _r32
        }).transform("translate3d(".concat(_s24, "px, ").concat(_a24, "px, 0px)"));
      }
    },
    setTransition: function setTransition(e) {
      var t = this;
      var i = t.slides;
      var s = t.$wrapperEl;
      if (i.transition(e), t.params.virtualTranslate && e !== 0) {
        var _a25 = !1;
        i.transitionEnd(function () {
          if (!_a25 && t && !t.destroyed) {
            _a25 = !0, t.animating = !1;
            for (var _e12 = ['webkitTransitionEnd', 'transitionend'], _i35 = 0; _i35 < _e12.length; _i35 += 1) s.trigger(_e12[_i35]);
          }
        });
      }
    }
  };
  var fe = {
    setTranslate: function setTranslate() {
      var e;
      var t = this.$el;
      var i = this.$wrapperEl;
      var a = this.slides;
      var r = this.width;
      var n = this.height;
      var o = this.rtlTranslate;
      var l = this.size;
      var d = this.params.cubeEffect;
      var h = this.isHorizontal();
      var p = this.virtual && this.params.virtual.enabled;
      var c = 0;
      d.shadow && (h ? ((e = i.find('.swiper-cube-shadow')).length === 0 && (e = s('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({
        height: "".concat(r, "px")
      })) : (e = t.find('.swiper-cube-shadow')).length === 0 && (e = s('<div class="swiper-cube-shadow"></div>'), t.append(e)));
      for (var _u9 = 0; _u9 < a.length; _u9 += 1) {
        var _v8 = a.eq(_u9);
        var _f7 = _u9;
        p && (_f7 = parseInt(_v8.attr('data-swiper-slide-index'), 10));
        var _m6 = 90 * _f7;
        var _g6 = Math.floor(_m6 / 360);
        o && (_m6 = -_m6, _g6 = Math.floor(-_m6 / 360));
        var _b6 = Math.max(Math.min(_v8[0].progress, 1), -1);
        var _w6 = 0;
        var _y4 = 0;
        var _x4 = 0;
        _f7 % 4 == 0 ? (_w6 = 4 * -_g6 * l, _x4 = 0) : (_f7 - 1) % 4 == 0 ? (_w6 = 0, _x4 = 4 * -_g6 * l) : (_f7 - 2) % 4 == 0 ? (_w6 = l + 4 * _g6 * l, _x4 = l) : (_f7 - 3) % 4 == 0 && (_w6 = -l, _x4 = 3 * l + 4 * l * _g6), o && (_w6 = -_w6), h || (_y4 = _w6, _w6 = 0);
        var _T4 = "rotateX(".concat(h ? 0 : -_m6, "deg) rotateY(").concat(h ? _m6 : 0, "deg) translate3d(").concat(_w6, "px, ").concat(_y4, "px, ").concat(_x4, "px)");
        if (_b6 <= 1 && _b6 > -1 && (c = 90 * _f7 + 90 * _b6, o && (c = 90 * -_f7 - 90 * _b6)), _v8.transform(_T4), d.slideShadows) {
          var _E4 = h ? _v8.find('.swiper-slide-shadow-left') : _v8.find('.swiper-slide-shadow-top');
          var _S3 = h ? _v8.find('.swiper-slide-shadow-right') : _v8.find('.swiper-slide-shadow-bottom');
          _E4.length === 0 && (_E4 = s("<div class=\"swiper-slide-shadow-".concat(h ? 'left' : 'top', "\"></div>")), _v8.append(_E4)), _S3.length === 0 && (_S3 = s("<div class=\"swiper-slide-shadow-".concat(h ? 'right' : 'bottom', "\"></div>")), _v8.append(_S3)), _E4.length && (_E4[0].style.opacity = Math.max(-_b6, 0)), _S3.length && (_S3[0].style.opacity = Math.max(_b6, 0));
        }
      }
      if (i.css({
        '-webkit-transform-origin': "50% 50% -".concat(l / 2, "px"),
        '-moz-transform-origin': "50% 50% -".concat(l / 2, "px"),
        '-ms-transform-origin': "50% 50% -".concat(l / 2, "px"),
        'transform-origin': "50% 50% -".concat(l / 2, "px")
      }), d.shadow) if (h) e.transform("translate3d(0px, ".concat(r / 2 + d.shadowOffset, "px, ").concat(-r / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(d.shadowScale, ")"));else {
        var _C = Math.abs(c) - 90 * Math.floor(Math.abs(c) / 90);
        var _M = 1.5 - (Math.sin(2 * _C * Math.PI / 360) / 2 + Math.cos(2 * _C * Math.PI / 360) / 2);
        var _P3 = d.shadowScale;
        var _z3 = d.shadowScale / _M;
        var _k = d.shadowOffset;
        e.transform("scale3d(".concat(_P3, ", 1, ").concat(_z3, ") translate3d(0px, ").concat(n / 2 + _k, "px, ").concat(-n / 2 / _z3, "px) rotateX(-90deg)"));
      }
      var $ = j.isSafari || j.isUiWebView ? -l / 2 : 0;
      i.transform("translate3d(0px,0,".concat($, "px) rotateX(").concat(this.isHorizontal() ? 0 : c, "deg) rotateY(").concat(this.isHorizontal() ? -c : 0, "deg)"));
    },
    setTransition: function setTransition(e) {
      var t = this.$el;
      this.slides.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e), this.params.cubeEffect.shadow && !this.isHorizontal() && t.find('.swiper-cube-shadow').transition(e);
    }
  };
  var me = {
    setTranslate: function setTranslate() {
      for (var _e13 = this.slides, _t34 = this.rtlTranslate, _i36 = 0; _i36 < _e13.length; _i36 += 1) {
        var _a26 = _e13.eq(_i36);
        var _r33 = _a26[0].progress;
        this.params.flipEffect.limitRotation && (_r33 = Math.max(Math.min(_a26[0].progress, 1), -1));
        var _n22 = -180 * _r33;
        var _o20 = 0;
        var _l18 = -_a26[0].swiperSlideOffset;
        var _d15 = 0;
        if (this.isHorizontal() ? _t34 && (_n22 = -_n22) : (_d15 = _l18, _l18 = 0, _o20 = -_n22, _n22 = 0), _a26[0].style.zIndex = -Math.abs(Math.round(_r33)) + _e13.length, this.params.flipEffect.slideShadows) {
          var _h15 = this.isHorizontal() ? _a26.find('.swiper-slide-shadow-left') : _a26.find('.swiper-slide-shadow-top');
          var _p14 = this.isHorizontal() ? _a26.find('.swiper-slide-shadow-right') : _a26.find('.swiper-slide-shadow-bottom');
          _h15.length === 0 && (_h15 = s("<div class=\"swiper-slide-shadow-".concat(this.isHorizontal() ? 'left' : 'top', "\"></div>")), _a26.append(_h15)), _p14.length === 0 && (_p14 = s("<div class=\"swiper-slide-shadow-".concat(this.isHorizontal() ? 'right' : 'bottom', "\"></div>")), _a26.append(_p14)), _h15.length && (_h15[0].style.opacity = Math.max(-_r33, 0)), _p14.length && (_p14[0].style.opacity = Math.max(_r33, 0));
        }
        _a26.transform("translate3d(".concat(_l18, "px, ").concat(_d15, "px, 0px) rotateX(").concat(_o20, "deg) rotateY(").concat(_n22, "deg)"));
      }
    },
    setTransition: function setTransition(e) {
      var t = this;
      var i = t.slides;
      var s = t.activeIndex;
      var a = t.$wrapperEl;
      if (i.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e), t.params.virtualTranslate && e !== 0) {
        var _r34 = !1;
        i.eq(s).transitionEnd(function () {
          if (!_r34 && t && !t.destroyed) {
            _r34 = !0, t.animating = !1;
            for (var _e14 = ['webkitTransitionEnd', 'transitionend'], _i37 = 0; _i37 < _e14.length; _i37 += 1) a.trigger(_e14[_i37]);
          }
        });
      }
    }
  };
  var ge = {
    setTranslate: function setTranslate() {
      for (var e = this.width, t = this.height, i = this.slides, a = this.$wrapperEl, r = this.slidesSizesGrid, n = this.params.coverflowEffect, l = this.isHorizontal(), d = this.translate, h = l ? e / 2 - d : t / 2 - d, p = l ? n.rotate : -n.rotate, c = n.depth, u = 0, v = i.length; u < v; u += 1) {
        var _f8 = i.eq(u);
        var _m7 = r[u];
        var _g7 = (h - _f8[0].swiperSlideOffset - _m7 / 2) / _m7 * n.modifier;
        var _b7 = l ? p * _g7 : 0;
        var _w7 = l ? 0 : p * _g7;
        var _y5 = -c * Math.abs(_g7);
        var _x5 = n.stretch;
        typeof _x5 === 'string' && _x5.indexOf('%') !== -1 && (_x5 = parseFloat(n.stretch) / 100 * _m7);
        var _T5 = l ? 0 : _x5 * _g7;
        var _E5 = l ? _x5 * _g7 : 0;
        Math.abs(_E5) < 0.001 && (_E5 = 0), Math.abs(_T5) < 0.001 && (_T5 = 0), Math.abs(_y5) < 0.001 && (_y5 = 0), Math.abs(_b7) < 0.001 && (_b7 = 0), Math.abs(_w7) < 0.001 && (_w7 = 0);
        var _S4 = "translate3d(".concat(_E5, "px,").concat(_T5, "px,").concat(_y5, "px)  rotateX(").concat(_w7, "deg) rotateY(").concat(_b7, "deg)");
        if (_f8.transform(_S4), _f8[0].style.zIndex = 1 - Math.abs(Math.round(_g7)), n.slideShadows) {
          var _C2 = l ? _f8.find('.swiper-slide-shadow-left') : _f8.find('.swiper-slide-shadow-top');
          var _M2 = l ? _f8.find('.swiper-slide-shadow-right') : _f8.find('.swiper-slide-shadow-bottom');
          _C2.length === 0 && (_C2 = s("<div class=\"swiper-slide-shadow-".concat(l ? 'left' : 'top', "\"></div>")), _f8.append(_C2)), _M2.length === 0 && (_M2 = s("<div class=\"swiper-slide-shadow-".concat(l ? 'right' : 'bottom', "\"></div>")), _f8.append(_M2)), _C2.length && (_C2[0].style.opacity = _g7 > 0 ? _g7 : 0), _M2.length && (_M2[0].style.opacity = -_g7 > 0 ? -_g7 : 0);
        }
      }
      (o.pointerEvents || o.prefixedPointerEvents) && (a[0].style.perspectiveOrigin = "".concat(h, "px 50%"));
    },
    setTransition: function setTransition(e) {
      this.slides.transition(e).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(e);
    }
  };
  var be = {
    init: function init() {
      var e = this.params.thumbs;
      var t = this.constructor;
      e.swiper instanceof t ? (this.thumbs.swiper = e.swiper, n.extend(this.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), n.extend(this.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      })) : n.isObject(e.swiper) && (this.thumbs.swiper = new t(n.extend({}, e.swiper, {
        watchSlidesVisibility: !0,
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      })), this.thumbs.swiperCreated = !0), this.thumbs.swiper.$el.addClass(this.params.thumbs.thumbsContainerClass), this.thumbs.swiper.on('tap', this.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var e = this.thumbs.swiper;
      if (e) {
        var _t35 = e.clickedIndex;
        var _i38 = e.clickedSlide;
        if (!(_i38 && s(_i38).hasClass(this.params.thumbs.slideThumbActiveClass) || _t35 == null)) {
          var _a27;
          if (_a27 = e.params.loop ? parseInt(s(e.clickedSlide).attr('data-swiper-slide-index'), 10) : _t35, this.params.loop) {
            var _r35 = this.activeIndex;
            this.slides.eq(_r35).hasClass(this.params.slideDuplicateClass) && (this.loopFix(), this._clientLeft = this.$wrapperEl[0].clientLeft, _r35 = this.activeIndex);
            var _n23 = this.slides.eq(_r35).prevAll("[data-swiper-slide-index=\"".concat(_a27, "\"]")).eq(0).index();
            var _o21 = this.slides.eq(_r35).nextAll("[data-swiper-slide-index=\"".concat(_a27, "\"]")).eq(0).index();
            _a27 = void 0 === _n23 ? _o21 : void 0 === _o21 ? _n23 : _o21 - _r35 < _r35 - _n23 ? _o21 : _n23;
          }
          this.slideTo(_a27);
        }
      }
    },
    update: function update(e) {
      var t = this.thumbs.swiper;
      if (t) {
        var _i39 = t.params.slidesPerView === 'auto' ? t.slidesPerViewDynamic() : t.params.slidesPerView;
        if (this.realIndex !== t.realIndex) {
          var _s25;
          var _a28 = t.activeIndex;
          if (t.params.loop) {
            t.slides.eq(_a28).hasClass(t.params.slideDuplicateClass) && (t.loopFix(), t._clientLeft = t.$wrapperEl[0].clientLeft, _a28 = t.activeIndex);
            var _r36 = t.slides.eq(_a28).prevAll("[data-swiper-slide-index=\"".concat(this.realIndex, "\"]")).eq(0).index();
            var _n24 = t.slides.eq(_a28).nextAll("[data-swiper-slide-index=\"".concat(this.realIndex, "\"]")).eq(0).index();
            _s25 = void 0 === _r36 ? _n24 : void 0 === _n24 ? _r36 : _n24 - _a28 == _a28 - _r36 ? _a28 : _n24 - _a28 < _a28 - _r36 ? _n24 : _r36;
          } else _s25 = this.realIndex;
          t.visibleSlidesIndexes && t.visibleSlidesIndexes.indexOf(_s25) < 0 && (t.params.centeredSlides ? _s25 = _s25 > _a28 ? _s25 - Math.floor(_i39 / 2) + 1 : _s25 + Math.floor(_i39 / 2) - 1 : _s25 > _a28 && (_s25 = _s25 - _i39 + 1), t.slideTo(_s25, e ? 0 : void 0));
        }
        var _o22 = 1;
        var _l19 = this.params.thumbs.slideThumbActiveClass;
        if (this.params.slidesPerView > 1 && !this.params.centeredSlides && (_o22 = this.params.slidesPerView), this.params.thumbs.multipleActiveThumbs || (_o22 = 1), _o22 = Math.floor(_o22), t.slides.removeClass(_l19), t.params.loop || t.params.virtual && t.params.virtual.enabled) for (var _d16 = 0; _d16 < _o22; _d16 += 1) t.$wrapperEl.children("[data-swiper-slide-index=\"".concat(this.realIndex + _d16, "\"]")).addClass(_l19);else for (var _h16 = 0; _h16 < _o22; _h16 += 1) t.slides.eq(this.realIndex + _h16).addClass(_l19);
      }
    }
  };
  var we = [R, q, K, U, Z, J, te, {
    name: 'mousewheel',
    params: {
      mousewheel: {
        enabled: !1,
        releaseOnEdges: !1,
        invert: !1,
        forceToAxis: !1,
        sensitivity: 1,
        eventsTarged: 'container'
      }
    },
    create: function create() {
      n.extend(this, {
        mousewheel: {
          enabled: !1,
          enable: ie.enable.bind(this),
          disable: ie.disable.bind(this),
          handle: ie.handle.bind(this),
          handleMouseEnter: ie.handleMouseEnter.bind(this),
          handleMouseLeave: ie.handleMouseLeave.bind(this),
          animateSlider: ie.animateSlider.bind(this),
          releaseScroll: ie.releaseScroll.bind(this),
          lastScrollTime: n.now(),
          lastEventBeforeSnap: void 0,
          recentWheelEvents: []
        }
      });
    },
    on: {
      init: function init() {
        !this.params.mousewheel.enabled && this.params.cssMode && this.mousewheel.disable(), this.params.mousewheel.enabled && this.mousewheel.enable();
      },
      destroy: function destroy() {
        this.params.cssMode && this.mousewheel.enable(), this.mousewheel.enabled && this.mousewheel.disable();
      }
    }
  }, {
    name: 'navigation',
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: !1,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden',
        lockClass: 'swiper-button-lock'
      }
    },
    create: function create() {
      n.extend(this, {
        navigation: {
          init: se.init.bind(this),
          update: se.update.bind(this),
          destroy: se.destroy.bind(this),
          onNextClick: se.onNextClick.bind(this),
          onPrevClick: se.onPrevClick.bind(this)
        }
      });
    },
    on: {
      init: function init() {
        this.navigation.init(), this.navigation.update();
      },
      toEdge: function toEdge() {
        this.navigation.update();
      },
      fromEdge: function fromEdge() {
        this.navigation.update();
      },
      destroy: function destroy() {
        this.navigation.destroy();
      },
      click: function click(e) {
        var t;
        var i = this.navigation;
        var a = i.$nextEl;
        var r = i.$prevEl;
        !this.params.navigation.hideOnClick || s(e.target).is(r) || s(e.target).is(a) || (a ? t = a.hasClass(this.params.navigation.hiddenClass) : r && (t = r.hasClass(this.params.navigation.hiddenClass)), !0 === t ? this.emit('navigationShow', this) : this.emit('navigationHide', this), a && a.toggleClass(this.params.navigation.hiddenClass), r && r.toggleClass(this.params.navigation.hiddenClass));
      }
    }
  }, {
    name: 'pagination',
    params: {
      pagination: {
        el: null,
        bulletElement: 'span',
        clickable: !1,
        hideOnClick: !1,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: !1,
        type: 'bullets',
        dynamicBullets: !1,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(e) {
          return e;
        },
        formatFractionTotal: function formatFractionTotal(e) {
          return e;
        },
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
        modifierClass: 'swiper-pagination-',
        currentClass: 'swiper-pagination-current',
        totalClass: 'swiper-pagination-total',
        hiddenClass: 'swiper-pagination-hidden',
        progressbarFillClass: 'swiper-pagination-progressbar-fill',
        progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
        clickableClass: 'swiper-pagination-clickable',
        lockClass: 'swiper-pagination-lock'
      }
    },
    create: function create() {
      n.extend(this, {
        pagination: {
          init: ae.init.bind(this),
          render: ae.render.bind(this),
          update: ae.update.bind(this),
          destroy: ae.destroy.bind(this),
          dynamicBulletIndex: 0
        }
      });
    },
    on: {
      init: function init() {
        this.pagination.init(), this.pagination.render(), this.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update();
      },
      snapIndexChange: function snapIndexChange() {
        this.params.loop || this.pagination.update();
      },
      slidesLengthChange: function slidesLengthChange() {
        this.params.loop && (this.pagination.render(), this.pagination.update());
      },
      snapGridLengthChange: function snapGridLengthChange() {
        this.params.loop || (this.pagination.render(), this.pagination.update());
      },
      destroy: function destroy() {
        this.pagination.destroy();
      },
      click: function click(e) {
        this.params.pagination.el && this.params.pagination.hideOnClick && this.pagination.$el.length > 0 && !s(e.target).hasClass(this.params.pagination.bulletClass) && (!0 === this.pagination.$el.hasClass(this.params.pagination.hiddenClass) ? this.emit('paginationShow', this) : this.emit('paginationHide', this), this.pagination.$el.toggleClass(this.params.pagination.hiddenClass));
      }
    }
  }, {
    name: 'scrollbar',
    params: {
      scrollbar: {
        el: null,
        dragSize: 'auto',
        hide: !1,
        draggable: !1,
        snapOnRelease: !0,
        lockClass: 'swiper-scrollbar-lock',
        dragClass: 'swiper-scrollbar-drag'
      }
    },
    create: function create() {
      n.extend(this, {
        scrollbar: {
          init: re.init.bind(this),
          destroy: re.destroy.bind(this),
          updateSize: re.updateSize.bind(this),
          setTranslate: re.setTranslate.bind(this),
          setTransition: re.setTransition.bind(this),
          enableDraggable: re.enableDraggable.bind(this),
          disableDraggable: re.disableDraggable.bind(this),
          setDragPosition: re.setDragPosition.bind(this),
          getPointerPosition: re.getPointerPosition.bind(this),
          onDragStart: re.onDragStart.bind(this),
          onDragMove: re.onDragMove.bind(this),
          onDragEnd: re.onDragEnd.bind(this),
          isTouched: !1,
          timeout: null,
          dragTimeout: null
        }
      });
    },
    on: {
      init: function init() {
        this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate();
      },
      update: function update() {
        this.scrollbar.updateSize();
      },
      resize: function resize() {
        this.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        this.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        this.scrollbar.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.scrollbar.setTransition(e);
      },
      destroy: function destroy() {
        this.scrollbar.destroy();
      }
    }
  }, {
    name: 'parallax',
    params: {
      parallax: {
        enabled: !1
      }
    },
    create: function create() {
      n.extend(this, {
        parallax: {
          setTransform: ne.setTransform.bind(this),
          setTranslate: ne.setTranslate.bind(this),
          setTransition: ne.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        this.params.parallax.enabled && (this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0);
      },
      init: function init() {
        this.params.parallax.enabled && this.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        this.params.parallax.enabled && this.parallax.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.params.parallax.enabled && this.parallax.setTransition(e);
      }
    }
  }, {
    name: 'zoom',
    params: {
      zoom: {
        enabled: !1,
        maxRatio: 3,
        minRatio: 1,
        toggle: !0,
        containerClass: 'swiper-zoom-container',
        zoomedSlideClass: 'swiper-slide-zoomed'
      }
    },
    create: function create() {
      var e = this;
      var t = {
        enabled: !1,
        scale: 1,
        currentScale: 1,
        isScaling: !1,
        gesture: {
          $slideEl: void 0,
          slideWidth: void 0,
          slideHeight: void 0,
          $imageEl: void 0,
          $imageWrapEl: void 0,
          maxRatio: 3
        },
        image: {
          isTouched: void 0,
          isMoved: void 0,
          currentX: void 0,
          currentY: void 0,
          minX: void 0,
          minY: void 0,
          maxX: void 0,
          maxY: void 0,
          width: void 0,
          height: void 0,
          startX: void 0,
          startY: void 0,
          touchesStart: {},
          touchesCurrent: {}
        },
        velocity: {
          x: void 0,
          y: void 0,
          prevPositionX: void 0,
          prevPositionY: void 0,
          prevTime: void 0
        }
      };
      'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (i) {
        t[i] = oe[i].bind(e);
      }), n.extend(e, {
        zoom: t
      });
      var i = 1;
      Object.defineProperty(e.zoom, 'scale', {
        get: function get() {
          return i;
        },
        set: function set(t) {
          if (i !== t) {
            var _s26 = e.zoom.gesture.$imageEl ? e.zoom.gesture.$imageEl[0] : void 0;
            var _a29 = e.zoom.gesture.$slideEl ? e.zoom.gesture.$slideEl[0] : void 0;
            e.emit('zoomChange', t, _s26, _a29);
          }
          i = t;
        }
      });
    },
    on: {
      init: function init() {
        this.params.zoom.enabled && this.zoom.enable();
      },
      destroy: function destroy() {
        this.zoom.disable();
      },
      touchStart: function touchStart(e) {
        this.zoom.enabled && this.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        this.zoom.enabled && this.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(e);
      },
      transitionEnd: function transitionEnd() {
        this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd();
      },
      slideChange: function slideChange() {
        this.zoom.enabled && this.params.zoom.enabled && this.params.cssMode && this.zoom.onTransitionEnd();
      }
    }
  }, {
    name: 'lazy',
    params: {
      lazy: {
        enabled: !1,
        loadPrevNext: !1,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: !1,
        elementClass: 'swiper-lazy',
        loadingClass: 'swiper-lazy-loading',
        loadedClass: 'swiper-lazy-loaded',
        preloaderClass: 'swiper-lazy-preloader'
      }
    },
    create: function create() {
      n.extend(this, {
        lazy: {
          initialImageLoaded: !1,
          load: le.load.bind(this),
          loadInSlide: le.loadInSlide.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1);
      },
      init: function init() {
        this.params.lazy.enabled && !this.params.loop && this.params.initialSlide === 0 && this.lazy.load();
      },
      scroll: function scroll() {
        this.params.freeMode && !this.params.freeModeSticky && this.lazy.load();
      },
      resize: function resize() {
        this.params.lazy.enabled && this.lazy.load();
      },
      scrollbarDragMove: function scrollbarDragMove() {
        this.params.lazy.enabled && this.lazy.load();
      },
      transitionStart: function transitionStart() {
        this.params.lazy.enabled && (this.params.lazy.loadOnTransitionStart || !this.params.lazy.loadOnTransitionStart && !this.lazy.initialImageLoaded) && this.lazy.load();
      },
      transitionEnd: function transitionEnd() {
        this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load();
      },
      slideChange: function slideChange() {
        this.params.lazy.enabled && this.params.cssMode && this.lazy.load();
      }
    }
  }, {
    name: 'controller',
    params: {
      controller: {
        control: void 0,
        inverse: !1,
        by: 'slide'
      }
    },
    create: function create() {
      n.extend(this, {
        controller: {
          control: this.params.controller.control,
          getInterpolateFunction: de.getInterpolateFunction.bind(this),
          setTranslate: de.setTranslate.bind(this),
          setTransition: de.setTransition.bind(this)
        }
      });
    },
    on: {
      update: function update() {
        this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
      },
      resize: function resize() {
        this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
      },
      observerUpdate: function observerUpdate() {
        this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
      },
      setTranslate: function setTranslate(e, t) {
        this.controller.control && this.controller.setTranslate(e, t);
      },
      setTransition: function setTransition(e, t) {
        this.controller.control && this.controller.setTransition(e, t);
      }
    }
  }, {
    name: 'a11y',
    params: {
      a11y: {
        enabled: !0,
        notificationClass: 'swiper-notification',
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide',
        lastSlideMessage: 'This is the last slide',
        paginationBulletMessage: 'Go to slide {{index}}'
      }
    },
    create: function create() {
      var e = this;
      n.extend(e, {
        a11y: {
          liveRegion: s("<span class=\"".concat(e.params.a11y.notificationClass, "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>"))
        }
      }), Object.keys(he).forEach(function (t) {
        e.a11y[t] = he[t].bind(e);
      });
    },
    on: {
      init: function init() {
        this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation());
      },
      toEdge: function toEdge() {
        this.params.a11y.enabled && this.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        this.params.a11y.enabled && this.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        this.params.a11y.enabled && this.a11y.updatePagination();
      },
      destroy: function destroy() {
        this.params.a11y.enabled && this.a11y.destroy();
      }
    }
  }, {
    name: 'history',
    params: {
      history: {
        enabled: !1,
        replaceState: !1,
        key: 'slides'
      }
    },
    create: function create() {
      n.extend(this, {
        history: {
          init: pe.init.bind(this),
          setHistory: pe.setHistory.bind(this),
          setHistoryPopState: pe.setHistoryPopState.bind(this),
          scrollToSlide: pe.scrollToSlide.bind(this),
          destroy: pe.destroy.bind(this)
        }
      });
    },
    on: {
      init: function init() {
        this.params.history.enabled && this.history.init();
      },
      destroy: function destroy() {
        this.params.history.enabled && this.history.destroy();
      },
      transitionEnd: function transitionEnd() {
        this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex);
      },
      slideChange: function slideChange() {
        this.history.initialized && this.params.cssMode && this.history.setHistory(this.params.history.key, this.activeIndex);
      }
    }
  }, {
    name: 'hash-navigation',
    params: {
      hashNavigation: {
        enabled: !1,
        replaceState: !1,
        watchState: !1
      }
    },
    create: function create() {
      n.extend(this, {
        hashNavigation: {
          initialized: !1,
          init: ce.init.bind(this),
          destroy: ce.destroy.bind(this),
          setHash: ce.setHash.bind(this),
          onHashCange: ce.onHashCange.bind(this)
        }
      });
    },
    on: {
      init: function init() {
        this.params.hashNavigation.enabled && this.hashNavigation.init();
      },
      destroy: function destroy() {
        this.params.hashNavigation.enabled && this.hashNavigation.destroy();
      },
      transitionEnd: function transitionEnd() {
        this.hashNavigation.initialized && this.hashNavigation.setHash();
      },
      slideChange: function slideChange() {
        this.hashNavigation.initialized && this.params.cssMode && this.hashNavigation.setHash();
      }
    }
  }, {
    name: 'autoplay',
    params: {
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !0,
        stopOnLastSlide: !1,
        reverseDirection: !1
      }
    },
    create: function create() {
      var e = this;
      n.extend(e, {
        autoplay: {
          running: !1,
          paused: !1,
          run: ue.run.bind(e),
          start: ue.start.bind(e),
          stop: ue.stop.bind(e),
          pause: ue.pause.bind(e),
          onVisibilityChange: function onVisibilityChange() {
            document.visibilityState === 'hidden' && e.autoplay.running && e.autoplay.pause(), document.visibilityState === 'visible' && e.autoplay.paused && (e.autoplay.run(), e.autoplay.paused = !1);
          },
          onTransitionEnd: function onTransitionEnd(t) {
            e && !e.destroyed && e.$wrapperEl && t.target === this && (e.$wrapperEl[0].removeEventListener('transitionend', e.autoplay.onTransitionEnd), e.$wrapperEl[0].removeEventListener('webkitTransitionEnd', e.autoplay.onTransitionEnd), e.autoplay.paused = !1, e.autoplay.running ? e.autoplay.run() : e.autoplay.stop());
          }
        }
      });
    },
    on: {
      init: function init() {
        this.params.autoplay.enabled && (this.autoplay.start(), document.addEventListener('visibilitychange', this.autoplay.onVisibilityChange));
      },
      beforeTransitionStart: function beforeTransitionStart(e, t) {
        this.autoplay.running && (t || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(e) : this.autoplay.stop());
      },
      sliderFirstMove: function sliderFirstMove() {
        this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause());
      },
      touchEnd: function touchEnd() {
        this.params.cssMode && this.autoplay.paused && !this.params.autoplay.disableOnInteraction && this.autoplay.run();
      },
      destroy: function destroy() {
        this.autoplay.running && this.autoplay.stop(), document.removeEventListener('visibilitychange', this.autoplay.onVisibilityChange);
      }
    }
  }, {
    name: 'effect-fade',
    params: {
      fadeEffect: {
        crossFade: !1
      }
    },
    create: function create() {
      n.extend(this, {
        fadeEffect: {
          setTranslate: ve.setTranslate.bind(this),
          setTransition: ve.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        if (this.params.effect === 'fade') {
          this.classNames.push("".concat(this.params.containerModifierClass, "fade"));
          var _e15 = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !0
          };
          n.extend(this.params, _e15), n.extend(this.originalParams, _e15);
        }
      },
      setTranslate: function setTranslate() {
        this.params.effect === 'fade' && this.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.params.effect === 'fade' && this.fadeEffect.setTransition(e);
      }
    }
  }, {
    name: 'effect-cube',
    params: {
      cubeEffect: {
        slideShadows: !0,
        shadow: !0,
        shadowOffset: 20,
        shadowScale: 0.94
      }
    },
    create: function create() {
      n.extend(this, {
        cubeEffect: {
          setTranslate: fe.setTranslate.bind(this),
          setTransition: fe.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        if (this.params.effect === 'cube') {
          this.classNames.push("".concat(this.params.containerModifierClass, "cube")), this.classNames.push("".concat(this.params.containerModifierClass, "3d"));
          var _e16 = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: !1,
            virtualTranslate: !0
          };
          n.extend(this.params, _e16), n.extend(this.originalParams, _e16);
        }
      },
      setTranslate: function setTranslate() {
        this.params.effect === 'cube' && this.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.params.effect === 'cube' && this.cubeEffect.setTransition(e);
      }
    }
  }, {
    name: 'effect-flip',
    params: {
      flipEffect: {
        slideShadows: !0,
        limitRotation: !0
      }
    },
    create: function create() {
      n.extend(this, {
        flipEffect: {
          setTranslate: me.setTranslate.bind(this),
          setTransition: me.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        if (this.params.effect === 'flip') {
          this.classNames.push("".concat(this.params.containerModifierClass, "flip")), this.classNames.push("".concat(this.params.containerModifierClass, "3d"));
          var _e17 = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !0
          };
          n.extend(this.params, _e17), n.extend(this.originalParams, _e17);
        }
      },
      setTranslate: function setTranslate() {
        this.params.effect === 'flip' && this.flipEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.params.effect === 'flip' && this.flipEffect.setTransition(e);
      }
    }
  }, {
    name: 'effect-coverflow',
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: !0
      }
    },
    create: function create() {
      n.extend(this, {
        coverflowEffect: {
          setTranslate: ge.setTranslate.bind(this),
          setTransition: ge.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        this.params.effect === 'coverflow' && (this.classNames.push("".concat(this.params.containerModifierClass, "coverflow")), this.classNames.push("".concat(this.params.containerModifierClass, "3d")), this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0);
      },
      setTranslate: function setTranslate() {
        this.params.effect === 'coverflow' && this.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.params.effect === 'coverflow' && this.coverflowEffect.setTransition(e);
      }
    }
  }, {
    name: 'thumbs',
    params: {
      thumbs: {
        multipleActiveThumbs: !0,
        swiper: null,
        slideThumbActiveClass: 'swiper-slide-thumb-active',
        thumbsContainerClass: 'swiper-container-thumbs'
      }
    },
    create: function create() {
      n.extend(this, {
        thumbs: {
          swiper: null,
          init: be.init.bind(this),
          update: be.update.bind(this),
          onThumbClick: be.onThumbClick.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var e = this.params.thumbs;
        e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
      },
      slideChange: function slideChange() {
        this.thumbs.swiper && this.thumbs.update();
      },
      update: function update() {
        this.thumbs.swiper && this.thumbs.update();
      },
      resize: function resize() {
        this.thumbs.swiper && this.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        this.thumbs.swiper && this.thumbs.update();
      },
      setTransition: function setTransition(e) {
        var t = this.thumbs.swiper;
        t && t.setTransition(e);
      },
      beforeDestroy: function beforeDestroy() {
        var e = this.thumbs.swiper;
        e && this.thumbs.swiperCreated && e && e.destroy();
      }
    }
  }];
  return void 0 === W.use && (W.use = W.Class.use, W.installModule = W.Class.installModule), W.use(we), W;
});
// # sourceMappingURL=swiper.min.js.map